// Imports des templates
import { AnimationCard } from './animation-card.js';
import { TEMPLATE as detailsTemplate, fillTemplate as fillDetailsTemplate, initAnimationSessionsMap, fetchAnimationPartenaires } from './animation-details.js';
import FormService from './form-service.js';
import TemplateService from './template-service.js';
import { fillTemplate, TEMPLATE } from './animation-card.js';

// Nous ne pouvons pas importer ParticipantManager ici car il importe showNotification de calendar.js
// import ParticipantManager from './participant-manager.js';
let ParticipantManager;


// Styles pour la modal
const modalStyles = `
    /* Appliquer Noto Sans à tous les éléments de la modal */
    .go-booking-modal,
    .go-booking-modal * {
        font-family: 'Noto Sans', sans-serif !important;
    }

    .go-booking-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .go-booking-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1;
    }

    .go-booking-modal-container {
        position: relative;
        background-color: #fff;
        padding: 2rem;
        border-radius: 8px;
        max-width: 600px;
        width: 90%;
        max-height: 90vh;
        overflow-y: auto;
        z-index: 2;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    .go-booking-modal-close {
        position: absolute;
        top: 1rem;
        right: 1rem;
        background: none;
        border: none;
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0.5rem;
        line-height: 1;
        color: #666;
    }

    .go-booking-modal-content {
        margin-top: 1rem;
    }

    .go-booking-form {
        margin-top: 2rem;
    }

    .form-group {
        margin-bottom: 1rem;
    }

    .form-group label {
        display: block;
        margin-bottom: 0.5rem;
        font-weight: 600;
    }

    .form-group input {
        width: 100%;
        padding: 0.5rem;
        border: 1px solid #ddd;
        border-radius: 4px;
    }

    .participants-supplementaires {
        margin-top: 2rem;
        padding-top: 1rem;
        border-top: 1px solid #eee;
    }

    .participant-group {
        background-color: #f9f9f9;
        padding: 1rem;
        margin-bottom: 1rem;
        border-radius: 4px;
    }

    .participant-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1rem;
    }

    .remove-participant-btn {
        border: none;
        color: #dc3545;
        font-size: 1.2rem;
        cursor: pointer;
        padding: 0.25rem 0.5rem;
    }

    .add-participant-btn {
        width: 100%;
        padding: 0.5rem;
        background-color: #f8f9fa;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        margin-top: 1rem;
    }

    .go-booking-submit-btn {
        width: 100%;
        padding: 0.75rem;
        background-color: #0d6efd;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        margin-top: 2rem;
    }

    .go-booking-submit-btn:hover {
        background-color: #0b5ed7;
    }

    /* Styles pour les filtres */
    .go-booking-filters {
        display: flex !important;
        flex-wrap: wrap !important;
        gap: 1rem !important;
        margin-bottom: 1.5rem !important;
        padding: 1rem !important;
        border-radius: 8px !important;
        background-color: #f8f9fa !important;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
    }

    .filter-group {
        flex: 1 !important;
        min-width: 200px !important;
    }

    .filter-group label {
        display: block !important;
        margin-bottom: 0.5rem !important;
        font-weight: 500 !important;
    }

    .filter-group select,
    .filter-group input {
        width: 100% !important;
        padding: 0.5rem !important;
        border: 1px solid #ced4da !important;
        border-radius: 4px !important;
        background-color: #fff !important;
    }

    .filter-buttons {
        display: flex !important;
        align-items: flex-end !important;
        gap: 0.5rem !important;
        min-width: 200px !important;
    }

    #apply-filters {
        flex-grow: 1 !important;
        padding: 0.5rem 1rem !important;
        background-color: #0d6efd !important;
        color: #fff !important;
        border: none !important;
        border-radius: 4px !important;
        cursor: pointer !important;
        font-weight: 500 !important;
    }

    #apply-filters:hover {
        background-color: #0b5ed7 !important;
    }
    
    #reset-filters {
        padding: 0.375rem 0.75rem !important;
        font-size: 0.875rem !important;
        background-color: #6c757d !important;
        color: #fff !important;
        border: none !important;
        border-radius: 4px !important;
        cursor: pointer !important;
    }

    #reset-filters:hover {
        background-color: #5c636a !important;
    }
    
    /* Media queries pour la responsivité */
    @media (max-width: 768px) {
        .go-booking-filters {
            flex-direction: column !important;
        }
        
        .filter-buttons {
            width: 100% !important;
            margin-top: 1rem !important;
        }
    }
    
    /* Style pour le message 'aucun résultat' */
    .no-results {
        padding: 1.5rem !important;
        margin: 1rem 0 !important;
        text-align: center !important;
        background-color: #f8f9fa !important;
        border-radius: 8px !important;
        color: #6c757d !important;
        font-weight: 500 !important;
    }
`;

// Système de gestion des clics précoces
window.goBookingClickQueue = [];
window.goBookingDOMReady = false;

function handleEarlyClick(eventId, element, originalEvent) {
    if (!window.goBookingDOMReady) {
        window.goBookingClickQueue.push({
            eventId: eventId,
            element: element,
            event: originalEvent
        });
        return true;
    }
    return false;
}

function replayQueuedClicks() {
    while (window.goBookingClickQueue.length > 0) {
        const queuedClick = window.goBookingClickQueue.shift();
        queuedClick.element.onclick(queuedClick.event);
    }
}

// Ajouter les variables globales pour la gestion des détails
window.isShowingDetails = false;
window.detailLockTimeout = null;
window.clickCooldown = false;
window.lastClickedEvent = null;

// Ajouter les styles au document
if (!document.getElementById('go-booking-modal-styles')) {
    const styleElement = document.createElement('style');
    styleElement.id = 'go-booking-modal-styles';
    styleElement.textContent = modalStyles;
    document.head.appendChild(styleElement);
}

// Ajouter l'importation de la police Noto Sans
function loadNotoSansFont() {
    if (!document.getElementById('noto-sans-font')) {
        const fontLink = document.createElement('link');
        fontLink.id = 'noto-sans-font';
        fontLink.rel = 'stylesheet';
        fontLink.href = 'https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;500;600;700;800;900&display=swap';
        document.head.appendChild(fontLink);
        
        // Ajouter un style global pour appliquer la police partout dans le plugin
        // en préservant uniquement les icônes Bootstrap
        const fontStyle = document.createElement('style');
        fontStyle.id = 'go-booking-font-style';
        fontStyle.textContent = `
            .go-booking-calendar-container,
            .go-booking-calendar-container *:not(.bi),
            .go-booking-modal,
            .go-booking-modal *:not(.bi) {
                font-family: 'Noto Sans', sans-serif !important;
            }
            
            /* Styles pour les icônes Bootstrap dans les boutons FullCalendar */
            .fc-button .bootstrap-icon {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            
            .fc-button .bootstrap-icon i {
                font-size: 1.2rem;
            }
        `;
        document.head.appendChild(fontStyle);
    }
}

// Fonction pour assombrir une couleur
function darkenColor(color, percent) {
    
    // Vérifier si la couleur est au format hexadécimal valide
    if (!/^#[0-9A-F]{6}$/i.test(color)) {
        console.error('Invalid color format:', color);
        return color;
    }
    
    try {
        const num = parseInt(color.replace("#", ""), 16),
            amt = Math.round(2.55 * percent),
            R = Math.max(Math.min((num >> 16) - amt, 255), 0),
            G = Math.max(Math.min((num >> 8 & 0x00FF) - amt, 255), 0),
            B = Math.max(Math.min((num & 0x0000FF) - amt, 255), 0);
        
        const newColor = "#" + (
            (R << 16) + 
            (G << 8) + 
            B
        ).toString(16).padStart(6, '0');
        
        return newColor;
    } catch (error) {
        return color;
    }
}

// Map pour stocker les couleurs des événements
const eventColors = new Map();

// Ajouter une variable globale pour suivre les instances de carte créées
window.goBookingMaps = window.goBookingMaps || {};

// Remplacer les chevrons FullCalendar par des icônes Bootstrap
function replaceFullCalendarIcons() {
    // Attendre que les boutons soient rendus
    setTimeout(() => {
        // Remplacer les chevrons de navigation
        const prevButton = document.querySelector('.fc-prev-button .fc-icon');
        const nextButton = document.querySelector('.fc-next-button .fc-icon');
        
        if (prevButton) {
            prevButton.innerHTML = '<i class="bi bi-chevron-left"></i>';
            prevButton.classList.remove('fc-icon', 'fc-icon-chevron-left');
            prevButton.classList.add('bootstrap-icon');
        }
        
        if (nextButton) {
            nextButton.innerHTML = '<i class="bi bi-chevron-right"></i>';
            nextButton.classList.remove('fc-icon', 'fc-icon-chevron-right');
            nextButton.classList.add('bootstrap-icon');
        }
        
        // Remplacer également les doubles chevrons si présents
        const prevYearButton = document.querySelector('.fc-prevYear-button .fc-icon');
        const nextYearButton = document.querySelector('.fc-nextYear-button .fc-icon');
        
        if (prevYearButton) {
            prevYearButton.innerHTML = '<i class="bi bi-chevron-double-left"></i>';
            prevYearButton.classList.remove('fc-icon', 'fc-icon-chevrons-left');
            prevYearButton.classList.add('bootstrap-icon');
        }
        
        if (nextYearButton) {
            nextYearButton.innerHTML = '<i class="bi bi-chevron-double-right"></i>';
            nextYearButton.classList.remove('fc-icon', 'fc-icon-chevrons-right');
            nextYearButton.classList.add('bootstrap-icon');
        }
        
        // Appliquer du style pour centrer les icônes Bootstrap
        const style = document.createElement('style');
        style.textContent = `
            .fc-button .bootstrap-icon {
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .fc-button .bootstrap-icon i {
                font-size: 1.2rem;
            }
        `;
        document.head.appendChild(style);
    }, 100);
}

// Appliquer le remplacement lors des changements de vue
function setupIconReplacement() {
    // S'assurer que les icônes sont remplacées au chargement initial
    replaceFullCalendarIcons();
    
    // Observer les changements qui pourraient réinitialiser les boutons
    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Vérifier si des boutons de navigation ont été ajoutés
                for (const node of mutation.addedNodes) {
                    if (node.classList && 
                        (node.classList.contains('fc-prev-button') || 
                         node.classList.contains('fc-next-button') ||
                         node.classList.contains('fc-prevYear-button') || 
                         node.classList.contains('fc-nextYear-button'))) {
                        replaceFullCalendarIcons();
                        return;
                    }
                }
            }
        }
    });
    
    // Observer le conteneur de la barre d'outils
    const toolbarContainer = document.querySelector('.fc-toolbar');
    if (toolbarContainer) {
        observer.observe(toolbarContainer, { 
            childList: true,
            subtree: true
        });
    }
}

// Ajouter cette variable globale au début du fichier, avant le DOMContentLoaded
window.goBookingCalendarFirstLoad = true;

// Modifier la fonction DocumentReady en ajoutant un timeout pour désactiver le flag de premier chargement
document.addEventListener('DOMContentLoaded', function() {
    
    // Charger la police Noto Sans
    loadNotoSansFont();
    
    
    // Ajouter les styles personnalisés
    addCustomDetailStyles();
    
    // Vérifier si les données du calendrier sont disponibles
    if (typeof goBookingCalendar === 'undefined') {
        return;
    }
    
    // S'assurer que le conteneur a la bonne classe
    const calendarContainer = document.getElementById('calendar');
    if (!calendarContainer) {
        return;
    }
    
    // Ajouter la classe conteneur si elle n'existe pas
    if (!calendarContainer.parentElement.classList.contains('go-booking-calendar-container')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'go-booking-calendar-container';
        calendarContainer.parentNode.insertBefore(wrapper, calendarContainer);
        wrapper.appendChild(calendarContainer);
    }
    
    // Fusionner les options par défaut avec les options personnalisées
    const calendarOptions = {
        ...goBookingCalendar.options,
        height: 'auto', // Permettre au calendrier de s'étendre naturellement
        contentHeight: 'auto', // Hauteur du contenu adaptative
        expandRows: true, // S'assurer que les lignes s'étendent pour remplir la hauteur disponible
        scrollTimeReset: false, // Ne pas réinitialiser le défilement
        fixedWeekCount: false, // Adapter le nombre de semaines à afficher au mois
        events: goBookingCalendar.events,
        // Personnaliser la barre d'outils - tout aligner à gauche
        headerToolbar: {
            left: 'title prev,next', // Titre et boutons de navigation alignés à gauche
            center: '', // Rien au centre
            right: '' // Rien à droite
        },
        // Désactiver les boutons pour changer de vue
        views: {
            dayGridMonth: {
                buttonText: 'Mois'
            },
            timeGridWeek: {
                buttonText: 'Semaine',
                display: 'none' // Cacher cette vue
            },
            listMonth: {
                buttonText: 'Liste',
                display: 'none' // Cacher cette vue
            }
        },
        // Forcer la vue en mode liste et empêcher le changement
        initialView: 'listMonth',
        eventClick: function(info) {
            
            // Si c'est un clic sur le bouton d'inscription, ouvrir la modale d'inscription
            if (info.jsEvent.target.closest('.go-booking-inscription-btn')) {
                openInscriptionModal(info.event);
                return false;
            }
            
            // Gérer le clic sur l'événement pour afficher/masquer les détails
            const eventId = info.event.id;
            const eventElement = info.el;
            const animationCard = eventElement.closest('.fc-flexbox-animation-card');
            
            if (!animationCard) {
                return;
            }

            const detailsContainer = animationCard.querySelector('.fc-flexbox-event-details');
            const chevronIcon = animationCard.querySelector('.chevron-icon');
            
            if (!detailsContainer) {
                return;
            }

            // Basculer l'affichage des détails
            const isVisible = detailsContainer.classList.contains('show');
            
            if (!isVisible) {
                // Masquer tous les autres détails ouverts
                document.querySelectorAll('.fc-flexbox-event-details.show').forEach(container => {
                    if (container !== detailsContainer) {
                        container.classList.remove('show');
                        container.style.display = 'none';
                        const otherChevron = container.closest('.fc-flexbox-animation-card')?.querySelector('.chevron-icon');
                        if (otherChevron) {
                            otherChevron.classList.remove('rotate');
                        }
                    }
                });

                // Afficher les détails de l'événement cliqué
                detailsContainer.classList.add('show');
                detailsContainer.style.display = 'block';
                if (chevronIcon) {
                    chevronIcon.classList.add('rotate');
                }

                // Initialiser les détails si ce n'est pas déjà fait
                if (!detailsContainer.getAttribute('data-initialized')) {
                    initEventDetails(eventId, detailsContainer);
                    detailsContainer.setAttribute('data-initialized', 'true');
                }
            } else {
                // Masquer les détails
                detailsContainer.classList.remove('show');
                detailsContainer.style.display = 'none';
                if (chevronIcon) {
                    chevronIcon.classList.remove('rotate');
                }
            }

            info.jsEvent.preventDefault();
            info.jsEvent.stopPropagation();
        },
        eventDidMount: function(info) {
            // Appliquer les styles de catégorie aux événements
            applyEventStyles(info.el, info.event);
            
            const event = info.event;
            const element = info.el;
            
            // Ajouter une classe unique pour cet événement
            element.classList.add(`event-${event.id}`);
            element.setAttribute('data-event-id', event.id);
            
            // Force la couleur d'arrière-plan directement sur l'élément
            if (event.backgroundColor) {
                element.style.setProperty('--fc-event-bg-color', event.backgroundColor, 'important');
                element.style.setProperty('background-color', event.backgroundColor, 'important');
            } else if (event.extendedProps.background_color) {
                element.style.setProperty('--fc-event-bg-color', event.extendedProps.background_color, 'important');
                element.style.setProperty('background-color', event.extendedProps.background_color, 'important');
            }
            
            // Appliquer les styles personnalisés à l'élément principal
            applyBackgroundStyles(element, event.extendedProps);
            
            // S'il s'agit de la vue liste, utiliser le contenu généré par eventContent
            if (element.classList.contains('fc-list-event')) {
                const templateData = {
                    time: info.timeText,
                    title: event.title,
                    lieu_depart: event.extendedProps.lieu_depart || '',
                    places_disponibles: event.extendedProps.places_disponibles || '',
                    id: event.id,
                    categories: event.extendedProps.categories || [],
                    description: event.extendedProps.description || '',
                    date_fin: event.extendedProps.date_fin || '',
                    territoire: event.extendedProps.territoire || '',
                    disable_native_inscription: event.extendedProps.disable_native_inscription || false,
                    external_inscription_url: event.extendedProps.external_inscription_url || '',
                    external_inscription_label: event.extendedProps.external_inscription_label || '',
                    date: event.start.toLocaleDateString('fr-FR', {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    },)
                };
                
                const renderedContent = fillTemplate(templateData);
                element.innerHTML = renderedContent;
                
                // Créer le conteneur des détails s'il n'existe pas
                let detailsContainer = element.querySelector('.fc-flexbox-event-details');
                if (!detailsContainer) {
                    detailsContainer = document.createElement('div');
                    detailsContainer.className = 'fc-flexbox-event-details';
                    element.appendChild(detailsContainer);
                }
            }
        },
        eventContent: function(arg) {
            const props = arg.event.extendedProps || {};
            
            
            // Convertir la date si nécessaire
            const startDate = arg.event.start instanceof Date ? arg.event.start : new Date(arg.event.start);
            
            // Préparer les données complètes pour l'animation
            const templateData = {
                time: arg.timeText || startDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
                title: arg.event.title,
                lieu_depart: props.lieu_depart || '',
                places_disponibles: props.places_disponibles || '',
                max_inscriptions_user: props.max_inscriptions_user || 1,
                id: arg.event.id,
                categories: props.categories || [],
                description: props.description || '',
                territoire: props.territoire || '',
                disable_native_inscription: props.disable_native_inscription === true,
                external_inscription_url: props.external_inscription_url || '',
                external_inscription_label: props.external_inscription_label || '',
                date: startDate.toLocaleDateString('fr-FR', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                })
            };
            
            // Créer une instance de AnimationCard
            const animationCard = new AnimationCard(templateData);
            const element = animationCard.element;
            
            // Stocker l'instance sur l'élément DOM pour référence future
            element._animationCard = animationCard;
            
            // Utiliser un MutationObserver pour détecter quand l'élément est inséré dans le DOM
            const observer = new MutationObserver((mutations, obs) => {
                if (document.contains(element)) {
                    console.log('Élément inséré dans le DOM, réinitialisation des gestionnaires');
                    animationCard.attachEventHandlers();
                    obs.disconnect();
                }
            });
            
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
            
            
            // Retourner l'élément DOM créé par AnimationCard
            return { domNodes: [element] };
        },
        datesSet: function(dateInfo) {
            // Ajouter un guard pour prévenir les appels récursifs
            if (window.isProcessingDateChange) {
                return;
            }
            
            window.isProcessingDateChange = true;
            
            try {
                // Obtenir les dates visibles du calendrier
                let visibleStart, visibleEnd;
                if (window.goBookingCalendarInstance) {
                    try {
                        const view = window.goBookingCalendarInstance.view;
                        if (view) {
                            visibleStart = view.activeStart;
                            visibleEnd = view.activeEnd;
                        }
                    } catch (error) {
                        console.warn('Erreur lors de la récupération des dates visibles:', error);
                    }
                }
                
                // Stocker les événements originaux si ce n'est pas déjà fait
                if (!window.originalEvents && goBookingCalendar.events) {
                    window.originalEvents = [...goBookingCalendar.events];
                }
                
                // Récupérer les événements
                const allEvents = window.originalEvents || goBookingCalendar.events || [];
                
                // Filtrer les événements pour la période visible
                const filteredEvents = allEvents.filter(event => {
                    const eventStart = new Date(event.start);
                    return eventStart >= visibleStart && eventStart < visibleEnd;
                });
                
                
                if (window.goBookingCalendarInstance) {
                    try {
                        // Approche multiméthode pour compatibilité avec différentes versions de FullCalendar
                        if (typeof window.goBookingCalendarInstance.removeAllEvents === 'function') {
                            // FullCalendar v5+
                            window.goBookingCalendarInstance.removeAllEvents();
                            window.goBookingCalendarInstance.addEventSource(filteredEvents);
                        } 
                        else if (typeof window.goBookingCalendarInstance.getEventSources === 'function') {
                            // Alternative: supprimer toutes les sources d'événements
                            const sources = window.goBookingCalendarInstance.getEventSources();
                            sources.forEach(source => source.remove());
                            window.goBookingCalendarInstance.addEventSource(filteredEvents);
                        }
                        else if (typeof window.goBookingCalendarInstance.getEvents === 'function') {
                            // Alternative: supprimer chaque événement individuellement
                            const events = window.goBookingCalendarInstance.getEvents();
                            events.forEach(event => event.remove());
                            window.goBookingCalendarInstance.addEventSource(filteredEvents);
                        }
                        else if (typeof window.goBookingCalendarInstance.refetchEvents === 'function') {
                            // Dernier recours: actualiser tous les événements
                            window.goBookingCalendarInstance.refetchEvents();
                        }
                        else {
                        }
                    } catch (error) {
                        console.error('Erreur lors de la mise à jour des événements:', error);
                    }
                }
                
                // Corriger les en-têtes
                setTimeout(fixDayHeaders, 50);
            } catch (error) {
                console.error('Erreur lors du traitement des événements:', error);
            } finally {
                setTimeout(() => {
                    window.isProcessingDateChange = false;
                }, 500);
            }
        },
        viewDidMount: function(viewInfo) {
            // Corriger les en-têtes de jours après le montage de la vue
            setTimeout(fixDayHeaders, 50);
        }
    };
    
    // Initialiser le calendrier
    try {
        // Créer le calendrier
        const calendar = new FullCalendar.Calendar(calendarContainer, calendarOptions);
        
        // Stocker les événements originaux pour le filtrage
        window.originalEvents = [...goBookingCalendar.events];
        
        // Rendre le calendrier
        calendar.render();
        
        
        // Exposer l'instance du calendrier globalement
        window.goBookingCalendarInstance = calendar;
        
        // Appliquer notre structure flexbox après le rendu initial
        setTimeout(fixDayHeaders, 100);
        setTimeout(fixDayHeaders, 500);
        
        // Mettre en place l'observation des mutations pour maintenir la structure flexbox
        setupCalendarObserver();
        
        // Désactiver les contraintes de hauteur après chaque changement de vue
        calendar.on('viewDidMount', function() {
            setTimeout(() => {
                // Désactiver tous les scrollers et limites de hauteur
                document.querySelectorAll('.fc-scroller').forEach(scroller => {
                    scroller.style.overflow = 'visible';
                    scroller.style.height = 'auto';
                    scroller.style.maxHeight = 'none';
                });
                
                document.querySelectorAll('.fc-view-harness').forEach(el => {
                    el.style.height = 'auto';
                    el.style.minHeight = '100%';
                });
                
                document.querySelectorAll('.fc-list, .fc-list-view').forEach(el => {
                    el.style.height = 'auto';
                    el.style.minHeight = '100%';
                });
            }, 0);
        });
    } catch (error) {
        console.error('Erreur lors de l\'initialisation du calendrier:', error);
    }

    // Traiter les styles des événements après le rendu
    if (goBookingCalendar.events) {
        processEvents(goBookingCalendar.events);
    }

    // Après l'initialisation du calendrier, remplacer les icônes
    setupIconReplacement();
    
    // Désactiver le flag de premier chargement après un délai pour permettre au calendrier de se stabiliser
    setTimeout(() => {
        window.goBookingCalendarFirstLoad = false;
    }, 2000);
});

async function openAnimationModal(event) {
    
    // Trouver l'élément de l'événement dans le DOM
    const eventElement = document.querySelector(`[data-event-id="${event.id}"]`);
    if (!eventElement) {
        console.error('Élément de l\'événement non trouvé');
        return;
    }
    
    // Trouver l'instance AnimationCard associée à cet élément
    const animationCard = eventElement._animationCard;
    if (!animationCard) {
        console.error('Instance AnimationCard non trouvée');
        return;
    }
    
    // Utiliser l'instance existante pour ouvrir la modale
    animationCard.openInscriptionModal();
    
    // Charger les sessions multiples
    const session = await loadAnimationSessions(event.id);
    
    // Si une session a été chargée, mettre à jour les informations
    if (session) {
        const dateElement = document.querySelector('.animation-date');
        if (dateElement) {
            dateElement.textContent = `${session.formatted_date} (${session.day_name})`;
        }
        
        const timeElement = document.querySelector('.animation-time');
        if (timeElement) {
            timeElement.textContent = session.horaire;
        }
        
        const placesElement = document.querySelector('.places-disponibles');
        if (placesElement) {
            placesElement.textContent = session.places_disponibles;
            placesElement.className = `places-disponibles badge bg-${session.places_disponibles > 0 ? 'success' : 'danger'}`;
        }
    }
}

// Exporter la fonction showNotification pour qu'elle puisse être importée dans d'autres modules
export function showNotification(type, message) {
    
    // Créer l'élément de notification
    const notification = document.createElement('div');
    notification.className = `alert alert-${type} notification`;
    notification.textContent = message;
    
    // Ajouter la notification au conteneur
    const container = document.querySelector('.notification-container');
    if (container) {
        container.appendChild(notification);
        
        // Supprimer la notification après 5 secondes
        setTimeout(() => {
            notification.remove();
        }, 5000);
    } else {
        // Créer un conteneur de notifications s'il n'existe pas
        const newContainer = document.createElement('div');
        newContainer.className = 'notification-container';
        newContainer.style.position = 'fixed';
        newContainer.style.top = '50%';
        newContainer.style.left = '50%';
        newContainer.style.transform = 'translate(-50%, -50%)';
        newContainer.style.zIndex = '9999';
        
        document.body.appendChild(newContainer);
        newContainer.appendChild(notification);
        
        // Supprimer la notification après 5 secondes
        setTimeout(() => {
            notification.remove();
            // Supprimer le conteneur s'il est vide
            if (newContainer.children.length === 0) {
                newContainer.remove();
            }
        }, 5000);
    }
}

// Charger dynamiquement le module ParticipantManager après avoir défini showNotification
// Cela résout les problèmes d'imports circulaires
(async function loadParticipantManager() {
    try {
        // Importer dynamiquement le module ParticipantManager
        const module = await import('./participant-manager.js');
        ParticipantManager = module.default;
    } catch (error) {
        console.error('Erreur lors du chargement du module ParticipantManager:', error);
        // Implémenter une version minimale de secours si nécessaire
        ParticipantManager = class {
            constructor() {
            }
        };
    }
})();

// Fonction helper pour appliquer les styles d'arrière-plan
function applyBackgroundStyles(element, props, isGridRow = false) {
    // Réinitialiser tous les styles de background pour éviter les résidus
    element.style.background = '';
    element.style.backgroundImage = 'none';
    element.style.backgroundColor = '';
    element.style.backgroundSize = '';
    element.style.backgroundPosition = '';
    element.style.backgroundRepeat = '';
    
    // Si ce n'est pas une ligne de grille et que l'élément est un enfant d'une carte d'animation,
    // le rendre transparent et sortir
    if (!isGridRow && element.closest('.fc-flexbox-animation-card')) {
        element.style.background = 'transparent';
        element.style.backgroundImage = 'none';
        element.style.backgroundColor = 'transparent';
        return;
    }
    
    // Vérification stricte pour use_gradient - convertir en booléen explicite
    const useGradient = props.use_gradient === true || props.use_gradient === "true" || props.use_gradient === 1;
    
    // Priorité à la décision de use_gradient, appliquer le gradient UNIQUEMENT si use_gradient est vrai
    if (useGradient && props.gradient_color_1 && props.gradient_color_2) {
        // Appliquer le dégradé seulement si use_gradient est strictement vrai et que les couleurs existent
        const color1 = props.gradient_color_1;
        const color2 = props.gradient_color_2;
        const angle = props.gradient_angle || 45;
        
        element.style.background = `linear-gradient(${angle}deg, ${color1}, ${color2})`;
        element.style.backgroundImage = `linear-gradient(${angle}deg, ${color1}, ${color2})`;
        element.style.backgroundColor = 'transparent';
    } 
    // Si use_gradient est false ou si les couleurs du gradient n'existent pas, appliquer la couleur de fond unique
    else if (props.background_color) {
        element.style.backgroundImage = 'none';
        element.style.backgroundColor = props.background_color;
        element.style.background = props.background_color;
    }
}

// Fonction pour traiter les styles des événements
function processEvents(events) {
    events.forEach(event => {
        
        // Convertir la date si nécessaire
        const startDate = event.start instanceof Date ? event.start : new Date(event.start);
        
        const eventData = {
            id: event.id,
            title: event.title,
            time: startDate ? startDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : '',
            date: startDate ? startDate.toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) : '',
            date_fin: event.extendedProps.date_fin || '',
            lieu_depart: event.extendedProps.lieu_depart,
            places_disponibles: event.extendedProps.places_disponibles,
            categories: event.extendedProps.categories,
            description: event.extendedProps.description,
            coordinates: event.extendedProps.coordinates,
            territoire: event.extendedProps.territoire,
            disable_native_inscription: event.extendedProps.disable_native_inscription,
            external_inscription_url: event.extendedProps.external_inscription_url,
            external_inscription_label: event.extendedProps.external_inscription_label,
            extendedProps: event.extendedProps
        };
        
        const animationCard = new AnimationCard(eventData);
        const element = document.querySelector(`[data-event-id="${event.id}"]`);
        if (element) {
            // Stocker l'instance sur l'élément DOM
            element._animationCard = animationCard;
        } else {
            console.warn('Element not found for event:', event.id);
        }
    });
}

// Nouvelle fonction pour appliquer les couleurs aux événements
function applyEventColors(el, event, isFirstEvent) {
    const props = event.extendedProps;
    
    // Éléments à styler
    const eventEl = el;
    const bgEl = eventEl.querySelector('.fc-event-main');
    const timeEl = eventEl.querySelector('.fc-event-time');
    const titleEl = eventEl.querySelector('.fc-event-title');
    
    // Vérification stricte pour use_gradient - convertir en booléen explicite
    const useGradient = props.use_gradient === true || props.use_gradient === "true" || props.use_gradient === 1;
    
    // Réinitialiser tous les styles d'arrière-plan d'abord
    if (eventEl) {
        eventEl.style.background = '';
        eventEl.style.backgroundColor = '';
        eventEl.style.backgroundImage = 'none';
    }
    
    if (bgEl) {
        bgEl.style.background = '';
        bgEl.style.backgroundColor = '';
        bgEl.style.backgroundImage = 'none';
    }
    
    // Priorité à la vérification de use_gradient
    if (props.background_color) {
        if (useGradient && props.gradient_color_1 && props.gradient_color_2) {
            // Appliquer le dégradé seulement si use_gradient est strictement vrai
            const angle = props.gradient_angle || 45;
            const gradientCSS = `linear-gradient(${angle}deg, ${props.gradient_color_1}, ${props.gradient_color_2})`;
            
            if (bgEl) {
                bgEl.style.backgroundImage = gradientCSS;
                bgEl.style.background = gradientCSS;
                bgEl.style.backgroundColor = 'transparent';
            }
            
            if (eventEl) {
                eventEl.style.backgroundImage = gradientCSS;
                eventEl.style.background = gradientCSS;
                eventEl.style.backgroundColor = 'transparent';
            }
        } else {
            // Si use_gradient est false, appliquer uniquement la couleur de fond
            const bgColor = props.background_color;
            
            if (bgEl) {
                bgEl.style.backgroundImage = 'none';
                bgEl.style.backgroundColor = bgColor;
                bgEl.style.background = bgColor;
            }
            
            if (eventEl) {
                eventEl.style.backgroundImage = 'none';
                eventEl.style.backgroundColor = bgColor;
                eventEl.style.background = bgColor;
            }
        }
        
        // Appliquer la couleur du texte indépendamment du dégradé
        if (props.text_color) {
            if (timeEl) timeEl.style.color = props.text_color;
            if (titleEl) titleEl.style.color = props.text_color;
        }
    }
}

// Cette fonction doit être ajoutée ou modifiée dans la partie où vous créez la structure flexbox
function applyFirstEventColorToHeader(dayContainer) {
    // Obtenir tous les événements du jour avec un ID d'événement
    const eventElements = dayContainer.querySelectorAll('[data-event-id]');
    const header = dayContainer.querySelector('.fc-flexbox-day-header') || dayContainer.querySelector('.fc-list-day');
    
    if (eventElements.length > 0 && header) {
        // Obtenir l'ID du premier événement
        const firstEventElement = eventElements[0];
        const eventId = firstEventElement.getAttribute('data-event-id');
        
        if (eventId) {
            
            // Réinitialiser les styles d'arrière-plan de l'en-tête
            header.style.background = '';
            header.style.backgroundColor = '';
            header.style.backgroundImage = 'none';
            
            // Trouver l'événement dans les données
            if (goBookingCalendar && goBookingCalendar.events) {
                const eventData = goBookingCalendar.events.find(e => e.id.toString() === eventId.toString());
                
                if (eventData && eventData.extendedProps) {
                    // Vérification stricte pour use_gradient - convertir en booléen explicite
                    const useGradient = eventData.extendedProps.use_gradient === true || 
                                       eventData.extendedProps.use_gradient === "true" || 
                                       eventData.extendedProps.use_gradient === 1 ||
                                       eventData.extendedProps.use_gradient === "1";
                    
                    
                    // Priorité à la vérification de use_gradient
                    if (useGradient && eventData.extendedProps.gradient_color_1 && eventData.extendedProps.gradient_color_2) {
                        const color1 = eventData.extendedProps.gradient_color_1;
                        const color2 = eventData.extendedProps.gradient_color_2;
                        const angle = eventData.extendedProps.gradient_angle || 45;
                        
                        const gradientCSS = `linear-gradient(${angle}deg, ${color1}, ${color2})`;
                        header.style.background = gradientCSS;
                        header.style.backgroundImage = gradientCSS;
                        header.style.backgroundColor = 'transparent';
                        
                    } else if (eventData.extendedProps.background_color) {
                        // Si use_gradient est false, appliquer uniquement la couleur de fond
                        const bgColor = eventData.extendedProps.background_color;
                        header.style.backgroundImage = 'none';
                        header.style.backgroundColor = bgColor;
                        header.style.background = bgColor;
                        
                    }
                    
                    // Assurer que les textes sont bien visibles indépendamment du type d'arrière-plan
                    const textElements = header.querySelectorAll('*');
                    textElements.forEach(el => {
                        el.style.color = '#FFFFFF';
                        el.style.textShadow = '0 1px 2px rgba(0, 0, 0, 0.3)';
                        el.style.position = 'relative';
                        el.style.zIndex = '2';
                    });
                }
            }
        }
    }
}

// Ajouter un verrou pour empêcher les reconstructions pendant l'affichage des détails
window.isShowingDetails = false;

// Modifier la fonction setupCalendarObserver pour mieux gérer le premier chargement
function setupCalendarObserver() {
    // Observer les changements dans le DOM qui pourraient nécessiter une restructuration
    const calendarContainer = document.getElementById('calendar');
    if (!calendarContainer) return;
    
    const observer = new MutationObserver(function(mutations) {
        // Vérifier si des détails sont actuellement affichés
        const hasOpenDetails = document.querySelector('.fc-flexbox-event-details.show') !== null;
        
        // Ne pas restructurer si des détails sont ouverts
        if (hasOpenDetails) {
            return;
        }
        
        let shouldFix = false;
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length > 0 || 
                mutation.type === 'attributes' || 
                (mutation.type === 'childList' && 
                (mutation.target.classList.contains('fc-list-table') || 
                 mutation.target.closest('.fc-list-table')))) {
                shouldFix = true;
            }
        });
        
        if (shouldFix) {
            fixDayHeaders();
        }
    });
    
    // Observer les changements avec une configuration complète
    observer.observe(calendarContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
    });
}

// Modifier la fonction fixDayHeaders pour préserver les détails ouverts
function fixDayHeaders() {
    // Éviter multiple exécutions simultanées
    if (window.isFixingHeaders) {
        return;
    }
    
    window.isFixingHeaders = true;
    
    try {
        // Créer l'interface de filtrage si elle n'existe pas
        if (!document.querySelector('.go-booking-filters')) {
            createFilterInterface();
        }
        
        // Sauvegarder les états des conteneurs de détails ouverts
        const openDetailStates = new Map();
        document.querySelectorAll('.fc-flexbox-event-details.show').forEach(detail => {
            const eventEl = detail.previousElementSibling;
            if (eventEl && eventEl.hasAttribute('data-event-id')) {
                const eventId = eventEl.getAttribute('data-event-id');
                openDetailStates.set(eventId, true);
            }
        });
        
        // Nettoyer d'abord toute structure flexbox existante pour éviter les duplications
        document.querySelectorAll('.fc-flexbox-container').forEach(container => {
            container.remove();
        });
        
        // Rechercher la table de liste des événements
        const listTable = document.querySelector('.fc-list-table');
        if (!listTable) {
            return;
        }
        
        // Créer un conteneur flexbox pour remplacer la table
        const flexContainer = document.createElement('div');
        flexContainer.className = 'fc-flexbox-container';
        
        // Trouver tous les jours dans la liste
        const dayRows = listTable.querySelectorAll('.fc-list-day');
        
        // Regrouper les événements par jour
        const dayGroups = {};
        
        dayRows.forEach(dayRow => {
            // Extraire la date du jour
            const dayHeader = dayRow.querySelector('.fc-list-day-cushion');
            if (!dayHeader) return;
            
            // Extraire uniquement la partie date (sans le jour de la semaine)
            const fullDateText = dayHeader.textContent.trim();
            const dateText = fullDateText.replace(/[a-zA-Z]+\s*/, '').trim(); // Supprime le jour de la semaine
            
            // Créer un groupe pour ce jour s'il n'existe pas
            if (!dayGroups[dateText]) {
                dayGroups[dateText] = {
                    dateText: dateText,
                    events: []
                };
            }
            
            // Trouver tous les événements qui suivent ce jour jusqu'au prochain jour
            let currentNode = dayRow.nextElementSibling;
            while (currentNode && !currentNode.classList.contains('fc-list-day')) {
                if (currentNode.classList.contains('fc-list-event')) {
                    dayGroups[dateText].events.push(currentNode);
                }
                currentNode = currentNode.nextElementSibling;
            }
        });
        
        // Créer la nouvelle structure flexbox pour chaque jour
        Object.values(dayGroups).forEach(dayGroup => {
            const dayContainer = document.createElement('div');
            dayContainer.className = 'fc-flexbox-day';
            
            // Créer l'en-tête du jour général (cette en-tête ne sera visible que si le groupe a des animations)
            const dayGeneralHeader = document.createElement('div');
            dayGeneralHeader.className = 'fc-flexbox-day-header';
            dayGeneralHeader.innerHTML = `
                <div class="fc-flexbox-day-date" style="position: relative; z-index: 2;">
                    <span style="color: white; text-decoration: none; font-weight: 800;">${formatDateHeader(dayGroup)}</span>
                </div>
                <div class="fc-flexbox-day-info" style="position: relative; z-index: 2;"></div>
            `;
            
            // Ajouter l'en-tête générale uniquement s'il n'y a pas d'animations ce jour
            if (dayGroup.events.length === 0) {
                dayContainer.appendChild(dayGeneralHeader);
                
                // Ajouter un message si aucun événement
                const noEventsMsg = document.createElement('div');
                noEventsMsg.className = 'fc-flexbox-no-events';
                noEventsMsg.textContent = 'Aucune animation pour cette journée';
                noEventsMsg.style.cssText = `
                    padding: 15px;
                    text-align: center;
                    color: #666;
                    font-style: italic;
                `;
                dayContainer.appendChild(noEventsMsg);
            } else {
                // Pour chaque événement, créer un conteneur autonome avec son propre en-tête
                dayGroup.events.forEach((eventRow, index) => {
                    // Créer un conteneur pour cette carte d'animation spécifique
                    const animationCardContainer = document.createElement('div');
                    animationCardContainer.className = 'fc-flexbox-animation-card';
                    animationCardContainer.style.cssText = `
                        margin-bottom: 1rem;
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                    `;
                    
                    // Cloner l'événement pour le nouvel affichage
                    const eventClone = eventRow.cloneNode(true);
                    
                    // Obtenir l'ID de l'événement pour référence
                    let eventId = '';
                    if (eventClone.hasAttribute('data-event-id')) {
                        eventId = eventClone.getAttribute('data-event-id');
                    } else {
                        // Essayez de trouver l'ID de l'événement à partir des classes
                        const classes = eventClone.className.split(' ');
                        for (const cls of classes) {
                            if (cls.startsWith('event-')) {
                                eventId = cls.replace('event-', '');
                                break;
                            }
                        }
                    }
                    
                    // Créer un en-tête individuel pour cette carte d'animation
                    const animationHeader = document.createElement('div');
                    animationHeader.className = 'fc-flexbox-day-header';
                    animationHeader.innerHTML = `
                        <div class="fc-flexbox-day-date" style="position: relative; z-index: 2;">
                            <span style="color: white; text-decoration: none; font-weight: 800; font-size: 1.2rem;">${formatDateHeader(dayGroup)}</span>
                        </div>
                        <div class="fc-flexbox-day-info" style="position: relative; z-index: 2;"></div>
                    `;
                    
                    // Créer un conteneur personnalisé pour cet événement
                    const eventContainer = document.createElement('div');
                    eventContainer.className = 'fc-flexbox-event';
                    
                    // Préserver les classes importantes
                    eventClone.classList.forEach(cls => {
                        if (cls.startsWith('event-') || cls.startsWith('fc-') || cls.includes('animation-')) {
                            eventContainer.classList.add(cls);
                        }
                    });
                    
                    // Ajouter l'ID de l'événement
                    if (eventId) {
                        eventContainer.setAttribute('data-event-id', eventId);
                    }
                    
                    // Transférer le contenu flexible
                    // Au lieu de cloner le contenu existant, créer un nouveau contenu avec AnimationCard
                    if (eventId && goBookingCalendar && goBookingCalendar.events) {
                        // Récupérer l'événement complet depuis les données
                        const originalEvent = goBookingCalendar.events.find(e => e.id.toString() === eventId.toString());
                        
                        if (originalEvent) {
                            // Convertir la date si nécessaire
                            const startDate = originalEvent.start instanceof Date ? originalEvent.start : new Date(originalEvent.start);
                            
                            // Préparer les données pour AnimationCard
                            const eventData = {
                                id: originalEvent.id,
                                title: originalEvent.title,
                                time: startDate ? startDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : '',
                                date: startDate ? startDate.toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) : '',
                                lieu_depart: originalEvent.extendedProps.lieu_depart,
                                places_disponibles: originalEvent.extendedProps.places_disponibles,
                                categories: originalEvent.extendedProps.categories,
                                description: originalEvent.extendedProps.description,
                                coordinates: originalEvent.extendedProps.coordinates,
                                territoire: originalEvent.extendedProps.territoire,
                                extendedProps: originalEvent.extendedProps
                            };
                            
                            
                            // Créer une nouvelle instance de AnimationCard
                            const animationCard = new AnimationCard(eventData);
                            
                            // Utiliser le HTML généré par AnimationCard
                            if (animationCard.element && animationCard.element.querySelector('.event-flex-container')) {
                                const newFlexContainer = animationCard.element.querySelector('.event-flex-container');
                                eventContainer.appendChild(newFlexContainer.cloneNode(true));
                                
                                // Stocker l'instance sur l'élément DOM pour référence future
                                eventContainer._animationCard = animationCard;
                                
                                // Réappliquer les styles d'arrière-plan après l'utilisation d'AnimationCard
                                if (originalEvent.extendedProps) {
                                    // Vérification stricte pour use_gradient
                                    const useGradient = originalEvent.extendedProps.use_gradient === true || 
                                                    originalEvent.extendedProps.use_gradient === "true" || 
                                                    originalEvent.extendedProps.use_gradient === 1 ||
                                                    originalEvent.extendedProps.use_gradient === "1";
                                    
                                    // Créer un style unique pour cette animation
                                    const styleId = `animation-style-${eventId}`;
                                    let styleEl = document.getElementById(styleId);
                                    if (!styleEl) {
                                        styleEl = document.createElement('style');
                                        styleEl.id = styleId;
                                        document.head.appendChild(styleEl);
                                    }

                                    // Réinitialiser les classes et attributs
                                    animationCardContainer.classList.remove('has-gradient-bg', 'has-solid-bg');
                                    
                                    // Garder l'attribut data-event-id
                                    animationCardContainer.setAttribute('data-event-id', eventId);

                                    // Priorité à la vérification de use_gradient
                                    if (useGradient && originalEvent.extendedProps.gradient_color_1 && originalEvent.extendedProps.gradient_color_2) {
                                        const color1 = originalEvent.extendedProps.gradient_color_1;
                                        const color2 = originalEvent.extendedProps.gradient_color_2;
                                        const angle = originalEvent.extendedProps.gradient_angle || 45;
                                        
                                        
                                        // Stocker les informations de gradient dans des attributs data
                                        animationCardContainer.setAttribute('data-gradient-color-1', color1);
                                        animationCardContainer.setAttribute('data-gradient-color-2', color2);
                                        animationCardContainer.setAttribute('data-gradient-angle', angle);
                                        animationCardContainer.classList.add('has-gradient-bg');

                                        // Créer les styles CSS avec !important pour tous les éléments
                                        styleEl.textContent = `
                                            .fc-flexbox-animation-card[data-event-id="${eventId}"].has-gradient-bg {
                                                background: linear-gradient(${angle}deg, ${color1}, ${color2}) !important;
                                                background-image: linear-gradient(${angle}deg, ${color1}, ${color2}) !important;
                                            }
                                            .fc-flexbox-animation-card[data-event-id="${eventId}"].has-gradient-bg .fc-flexbox-day-header,
                                            .fc-flexbox-animation-card[data-event-id="${eventId}"].has-gradient-bg .fc-flexbox-event,
                                            .fc-flexbox-animation-card[data-event-id="${eventId}"].has-gradient-bg .event-flex-container {
                                                background: transparent !important;
                                                background-image: none !important;
                                                background-color: transparent !important;
                                            }
                                        `;
                                    } 
                                    else if (originalEvent.extendedProps.background_color) {
                                        const bgColor = originalEvent.extendedProps.background_color;
                                        
                                        
                                        // Stocker la couleur dans un attribut data
                                        animationCardContainer.setAttribute('data-background-color', bgColor);
                                        animationCardContainer.classList.add('has-solid-bg');

                                        // Créer les styles CSS avec !important pour tous les éléments
                                        styleEl.textContent = `
                                            .fc-flexbox-animation-card[data-event-id="${eventId}"].has-solid-bg {
                                                background: ${bgColor} !important;
                                                background-color: ${bgColor} !important;
                                            }
                                            .fc-flexbox-animation-card[data-event-id="${eventId}"].has-solid-bg .fc-flexbox-day-header,
                                            .fc-flexbox-animation-card[data-event-id="${eventId}"].has-solid-bg .fc-flexbox-event,
                                            .fc-flexbox-animation-card[data-event-id="${eventId}"].has-solid-bg .event-flex-container {
                                                background: transparent !important;
                                                background-image: none !important;
                                                background-color: transparent !important;
                                            }
                                        `;
                                    }
                                }
                            } else {
                                console.warn('AnimationCard n\'a pas généré d\'élément valide pour l\'événement:', eventId);
                                
                                // Fallback : cloner le contenu existant si AnimationCard échoue
                                const flexContainer = eventClone.querySelector('.event-flex-container');
                                if (flexContainer) {
                                    eventContainer.appendChild(flexContainer.cloneNode(true));
                                } else {
                                    const content = eventClone.querySelector('td');
                                    if (content) {
                                        eventContainer.innerHTML = content.innerHTML;
                                    }
                                }
                            }
                        } else {
                            console.warn('Événement non trouvé dans les données:', eventId);
                            
                            // Fallback : cloner le contenu existant si l'événement n'est pas trouvé
                            const flexContainer = eventClone.querySelector('.event-flex-container');
                            if (flexContainer) {
                                eventContainer.appendChild(flexContainer.cloneNode(true));
                            } else {
                                const content = eventClone.querySelector('td');
                                if (content) {
                                    eventContainer.innerHTML = content.innerHTML;
                                }
                            }
                        }
                    } else {
                        // Fallback : cloner le contenu existant si l'ID n'est pas disponible
                        const flexContainer = eventClone.querySelector('.event-flex-container');
                        if (flexContainer) {
                            eventContainer.appendChild(flexContainer.cloneNode(true));
                        } else {
                            const content = eventClone.querySelector('td');
                            if (content) {
                                eventContainer.innerHTML = content.innerHTML;
                            }
                        }
                    }
                    
                    // Définir les border-radius pour l'affichage
                    animationCardContainer.style.borderRadius = '12px';
                    animationCardContainer.style.overflow = 'hidden';
                    
                    // Supprimer les border-radius des éléments enfants
                    animationHeader.style.borderRadius = '';
                    eventContainer.style.borderRadius = '';
                    
                    // Créer un conteneur pour les détails (initialement caché)
                    const detailsContainer = document.createElement('div');
                    detailsContainer.className = 'fc-flexbox-event-details';
                    
                    
                    // Ajouter l'en-tête et le conteneur d'événement à la carte d'animation
                    animationCardContainer.appendChild(animationHeader);
                    animationCardContainer.appendChild(eventContainer);
                    animationCardContainer.appendChild(detailsContainer);
                    
                    
                    // Ajouter la carte complète au conteneur de jour
                    dayContainer.appendChild(animationCardContainer);
                    
                    // Gestionnaire d'événement pour l'ouverture des détails
                    eventContainer.onclick = function(e) {
                        // Vérifier si le clic vient d'un élément interactif
                        const isInscriptionBtn = e.target.closest('.go-booking-inscription-btn');
                        const isChevron = e.target.closest('.chevron-icon');
                        
                        // Si c'est un bouton d'inscription, ne rien faire et laisser l'événement se propager
                        if (isInscriptionBtn) {
                            return;
                        }
                        
                        // Pour tous les autres clics, empêcher la propagation par défaut
                        e.preventDefault();
                        e.stopPropagation();
                        
                        // Si c'est le chevron, ne rien faire d'autre
                        if (isChevron) {
                            return;
                        }
                        
                        const detailsEl = this.nextElementSibling;
                        const chevron = this.querySelector('.chevron-icon');
                        
                        // Si les détails sont déjà affichés, les masquer
                        if (detailsEl.classList.contains('show')) {
                            detailsEl.classList.remove('show');
                            if (chevron) {
                                chevron.classList.remove('rotate');
                            }
                            return;
                        }
                        
                        // Masquer tous les autres détails ouverts
                        document.querySelectorAll('.fc-flexbox-event-details.show').forEach(d => {
                            if (d !== detailsEl) {
                                d.classList.remove('show');
                                const prevEvent = d.previousElementSibling;
                                if (prevEvent) {
                                    const prevChevron = prevEvent.querySelector('.chevron-icon');
                                    if (prevChevron) {
                                        prevChevron.classList.remove('rotate');
                                    }
                                }
                            }
                        });
                        
                        // Afficher les détails
                        detailsEl.classList.add('show');
                        if (chevron) {
                            chevron.classList.add('rotate');
                        }
                        
                        // Initialiser les détails si nécessaire
                        if (eventId && !detailsEl.hasAttribute('data-initialized')) {
                            initEventDetails(eventId, detailsEl);
                            detailsEl.setAttribute('data-initialized', 'true');
                        }
                        
                    };
                    
                    // Reconstruire les événements qui étaient ouverts
                    if (eventId && openDetailStates.has(eventId)) {
                        
                        // Simuler un clic sur l'événement
                        setTimeout(() => {
                            eventContainer.click();
                        }, 250);
                    }
                });
            }
            
            flexContainer.appendChild(dayContainer);
        });
        
        // Insérer la structure flexbox après la table
        listTable.parentNode.insertBefore(flexContainer, listTable.nextSibling);
        
        // Marquer la table comme convertie pour la masquer via CSS
        listTable.classList.add('flexbox-converted');
        
        // Restaurer les états des détails ouverts après la restructuration
        openDetailStates.forEach((isOpen, eventId) => {
            const eventEl = document.querySelector(`.fc-flexbox-event[data-event-id="${eventId}"]`);
            if (eventEl) {
                const detailsEl = eventEl.nextElementSibling;
                if (detailsEl && detailsEl.classList.contains('fc-flexbox-event-details')) {
                    detailsEl.classList.add('show');
                    detailsEl.style.display = 'block';
                    const chevron = eventEl.querySelector('.chevron-icon');
                    if (chevron) {
                        chevron.classList.add('rotate');
                    }
                }
            }
        });
        
    } catch (error) {
        console.error('Erreur lors de la correction des en-têtes:', error);
    } finally {
        // Libérer le verrou après un certain délai
        setTimeout(() => {
            window.isFixingHeaders = false;
        }, 200);
    }
}

/**
 * Initialise la carte pour une animation en affichant toutes les localisations des sessions
 */
async function initMapForEvent(eventId, mapId) {
    try {
        
        // Vérifier si la fonction d'initialisation de carte d'animation-details.js est disponible
        if (typeof window.initAnimationSessionsMap === 'function') {
            return window.initAnimationSessionsMap(eventId, mapId);
        }
        
        // Récupérer toutes les sessions de l'animation
        const sessions = await loadAnimationSessions(eventId);
        if (!sessions) return;
        
        // Créer un tableau pour stocker toutes les coordonnées valides
        const validLocations = [];
        
        // Si sessions est un tableau (plusieurs sessions), parcourir chaque session
        if (Array.isArray(sessions)) {
            sessions.forEach(session => {
                if (isValidCoordinates(session.latitude, session.longitude)) {
                    validLocations.push({
                        lat: parseFloat(session.latitude),
                        lng: parseFloat(session.longitude),
                        title: `${session.formatted_date} - ${session.horaire}`,
                        sessionId: session.id
                    });
                }
            });
        } 
        // Si sessions est un objet unique (une seule session)
        else if (isValidCoordinates(sessions.latitude, sessions.longitude)) {
            validLocations.push({
                lat: parseFloat(sessions.latitude),
                lng: parseFloat(sessions.longitude),
                title: `${sessions.formatted_date} - ${sessions.horaire}`,
                sessionId: sessions.id
            });
        }
        
        // Si aucune localisation valide n'a été trouvée, vérifier la localisation principale de l'animation
        if (validLocations.length === 0) {
            const animationData = await fetchAnimationDetails(eventId);
            if (isValidCoordinates(animationData.latitude, animationData.longitude)) {
                validLocations.push({
                    lat: parseFloat(animationData.latitude),
                    lng: parseFloat(animationData.longitude),
                    title: animationData.title || 'Localisation principale',
                    isMain: true
                });
            }
        }
        
        // Si aucune localisation valide n'a été trouvée, ne pas afficher la carte
        if (validLocations.length === 0) {
            document.getElementById(mapId).style.display = 'none';
            return;
        }
        
        // Afficher la carte
        document.getElementById(mapId).style.display = 'block';
        
        // Initialiser la carte avec Leaflet
        await waitForLeaflet();
        
        // Créer la carte
        const map = L.map(mapId);
        
        // Ajouter le fond de carte OpenStreetMap
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);
        
        // Ajouter un marqueur pour chaque localisation valide
        const bounds = L.latLngBounds();
        
        validLocations.forEach(location => {
            const marker = L.marker([location.lat, location.lng]).addTo(map);
            
            // Ajouter une popup avec les informations de la session
            marker.bindPopup(location.title);
            
            // Ajouter les coordonnées aux limites pour le centrage
            bounds.extend([location.lat, location.lng]);
            
            // Si c'est une session, ajouter des données pour l'interaction
            if (location.sessionId) {
                marker._sessionId = location.sessionId;
                
                // Ajouter un événement de clic sur le marqueur pour sélectionner la session
                marker.on('click', function() {
                    // Trouver et cliquer sur le bouton de la session correspondante
                    const sessionButton = document.querySelector(`.session-item[data-session-id="${location.sessionId}"]`);
                    if (sessionButton) {
                        sessionButton.click();
                    }
                });
            }
        });
        
        // Ajuster la vue de la carte pour montrer tous les marqueurs
        if (validLocations.length > 1) {
            map.fitBounds(bounds, { padding: [30, 30] });
        } else {
            map.setView([validLocations[0].lat, validLocations[0].lng], 15);
        }
        
        return map;
    } catch (error) {
        document.getElementById(mapId).style.display = 'none';
    }
}

// Fonction pour récupérer les détails d'une animation
async function fetchAnimationDetails(eventId) {
    try {        
        const params = new URLSearchParams({
            action: 'gobooking_get_animation_details',
            nonce: goBookingData.nonce,
            animation_id: eventId,
            include_featured_image: true
        });
        
        
        const response = await fetch(goBookingData.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: params
        });

        const result = await response.json();
        
        if (!result.success) {
            console.error('Erreur lors de la récupération des détails:', result.message);
            return null;
        }

        return result.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des détails de l\'animation:', error);
        return null;
    }
}

// Modification de la fonction initEventDetails pour utiliser la nouvelle approche d'initialisation de carte
async function initEventDetails(eventId, detailsContainer) {
    
    const fcEvent = window.goBookingCalendarInstance.getEventById(eventId);
    if (!fcEvent) {
        console.error('Événement non trouvé:', eventId);
        return;
    }

    // Préparer les données pour le template
    const templateData = {
        id: eventId,
        title: fcEvent.title,
        date: fcEvent.start.toLocaleDateString('fr-FR', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }),
        time: `${new Date(fcEvent.start).toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})} - ${new Date(fcEvent.end).toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})}`,
        lieu_depart: fcEvent.extendedProps.lieu_depart,
        places_disponibles: fcEvent.extendedProps.places_disponibles,
        description: fcEvent.extendedProps.description || '',
        categories: fcEvent.extendedProps.categories || [],
        latitude: fcEvent.extendedProps.latitude,
        longitude: fcEvent.extendedProps.longitude,
        adresse: fcEvent.extendedProps.adresse,
        territoire: fcEvent.extendedProps.territoire,
        disable_native_inscription: fcEvent.extendedProps.disable_native_inscription,
        external_inscription_url: fcEvent.extendedProps.external_inscription_url,
        external_inscription_label: fcEvent.extendedProps.external_inscription_label
    };

    // Récupérer les partenaires de l'animation
    try {
        const partenaires = await fetchAnimationPartenaires(eventId);
        if (partenaires && partenaires.length > 0) {
            templateData.partenaires = partenaires;
        }
    } catch (error) {
        console.error('Erreur lors de la récupération des partenaires:', error);
    }

    try {
        // Utiliser directement le template importé
        const html = fillDetailsTemplate(templateData);
        
        detailsContainer.innerHTML = html;
        
        // Attendre que le DOM soit mis à jour
        await new Promise(resolve => setTimeout(resolve, 100));
        
        const mapContainer = document.getElementById(`map-${eventId}`);
        
        // Initialiser la carte si des coordonnées sont disponibles
        if (fcEvent.extendedProps.latitude && fcEvent.extendedProps.longitude) {
            if (mapContainer) {
                await initMapForEvent(eventId, `map-${eventId}`);
            } else {
            }
        } else {
        }

    } catch (error) {
        console.error('Erreur lors du chargement des détails:', error);
        detailsContainer.innerHTML = '<div class="alert alert-danger">Erreur lors du chargement des détails</div>';
    }
}

// Initialisation du système de file d'attente
jQuery(document).ready(function($) {
    window.goBookingDOMReady = true;
    replayQueuedClicks();
});

function isValidCoordinates(lat, lng) {
    return !isNaN(lat) && !isNaN(lng) && 
           lat >= -90 && lat <= 90 && 
           lng >= -180 && lng <= 180;
}

function waitForLeaflet(timeout = 5000) {
    return new Promise((resolve, reject) => {
        if (typeof L !== 'undefined') return resolve();
        
        const start = Date.now();
        const interval = setInterval(() => {
            if (typeof L !== 'undefined') {
                clearInterval(interval);
                resolve();
            } else if (Date.now() - start > timeout) {
                clearInterval(interval);
                reject(new Error('Leaflet not loaded'));
            }
        }, 100);
    });
}

function cleanupMap(mapId) {
    if (window.goBookingMaps?.[mapId]) {
        window.goBookingMaps[mapId].remove();
        delete window.goBookingMaps[mapId];
    }
}

// Fonction pour filtrer les événements
function filterEvents() {
    // const selectedCity = document.getElementById('filter-city')?.value || 'all';
    const selectedTerritory = document.getElementById('filter-territory')?.value || 'all';
    const selectedCategory = document.getElementById('filter-category')?.value || 'all';
    const selectedDate = document.getElementById('filter-date')?.value || '';

    
    // Sauvegarder les filtres en session
    sessionStorage.setItem('goBookingFilters', JSON.stringify({
        // city: selectedCity,
        territory: selectedTerritory,
        category: selectedCategory,
        date: selectedDate
    }));
    
    if (!window.goBookingCalendarInstance) return;
    
    // Récupérer la source d'événements principale
    const eventSources = window.goBookingCalendarInstance.getEventSources();
    if (eventSources.length === 0) {
        console.error('Aucune source d\'événements trouvée');
        return;
    }
    
    // Récupérer tous les événements originaux
    const allEvents = window.originalEvents || goBookingCalendar.events || [];
    
    // Appliquer les filtres
    let filteredEvents = [...allEvents];
    
    // if (selectedCity !== 'all') {
    //     filteredEvents = filteredEvents.filter(event => 
    //         event.extendedProps?.ville === selectedCity
    //     );
    // }

    if (selectedTerritory !== 'all') {
        filteredEvents = filteredEvents.filter(event => {
            // S'il n'y a pas de propriétés étendues ou pas de territoire, exclure l'événement
            if (!event.extendedProps || !event.extendedProps.territoire) return false;
            
            // Diviser la chaîne de territoires en tableau
            const territoires = event.extendedProps.territoire.split('|').map(t => t.trim());
            
            // Vérifier si le territoire sélectionné est dans le tableau
            return territoires.includes(selectedTerritory);
        });
    }
    
    if (selectedCategory !== 'all') {
        filteredEvents = filteredEvents.filter(event => {
            if (!event.extendedProps) return false;
            const categories = event.extendedProps.categories || [];
            return categories.some(cat => 
                (typeof cat === 'string' && cat === selectedCategory) || 
                (typeof cat === 'object' && cat.name === selectedCategory)
            );
        });
    }
    
    if (selectedDate) {
        const filterDate = new Date(selectedDate);
        filteredEvents = filteredEvents.filter(event => {
            const eventStartDate = new Date(event.start);
            
            // Vérifier si l'événement a une date de fin
            let eventEndDate = null;
            if (event.extendedProps && event.extendedProps.date_fin) {
                eventEndDate = new Date(event.extendedProps.date_fin);
            }
            
            // L'événement correspond si:
            // 1. La date de début correspond à la date de filtrage
            const startDateMatches = (
                eventStartDate.getFullYear() === filterDate.getFullYear() &&
                eventStartDate.getMonth() === filterDate.getMonth() &&
                eventStartDate.getDate() === filterDate.getDate()
            );
            
            // 2. OU la date de filtrage est entre la date de début et la date de fin
            const dateIsBetween = eventEndDate && 
                eventStartDate <= filterDate && 
                filterDate <= eventEndDate;
                
            return startDateMatches || dateIsBetween;
        });
    }
    
    
    // Afficher un message si aucun résultat
    const calendarContainer = document.querySelector('.go-booking-calendar-container');
    if (filteredEvents.length === 0) {
        // Créer ou afficher le message "Aucun résultat"
        let noResults = document.querySelector('.go-booking-no-results');
        if (!noResults) {
            noResults = document.createElement('div');
            noResults.className = 'go-booking-no-results';
            noResults.innerHTML = '<p>Aucune animation ne correspond aux critères sélectionnés</p>';
            if (calendarContainer) {
                calendarContainer.appendChild(noResults);
            }
        } else {
            noResults.style.display = 'block';
        }
    } else {
        // Masquer le message s'il existe
        const noResults = document.querySelector('.go-booking-no-results');
        if (noResults) {
            noResults.style.display = 'none';
        }
    }
    
    // Approche utilisant le comportement natif de FullCalendar
    // 1. Supprimer toutes les sources d'événements existantes
    eventSources.forEach(source => source.remove());
    
    // 2. Ajouter une nouvelle source avec les événements filtrés
    window.goBookingCalendarInstance.addEventSource(filteredEvents);
    
    // 3. Forcer un refetchEvents pour recharger proprement
    window.goBookingCalendarInstance.refetchEvents();
}

// Fonction pour créer l'interface de filtrage
function createFilterInterface() {
    // Vérifier si l'interface existe déjà
    if (document.querySelector('.go-booking-filters')) return;
    
    
    // Créer le conteneur des filtres
    const filtersContainer = document.createElement('div');
    filtersContainer.className = 'go-booking-filters';
    
    // Récupérer toutes les villes, territoires et catégories uniques
    // const cities = new Set();
    const territories = new Set();
    const categories = new Set();
    const allEvents = window.originalEvents || goBookingCalendar.events || [];
    
    
    allEvents.forEach(event => {
        // if (event.extendedProps.ville) {
        //     cities.add(event.extendedProps.ville);
        // }
        if (event.extendedProps && event.extendedProps.territoire) {
            // Diviser la chaîne de territoires et ajouter chaque territoire individuellement
            const territoiresList = event.extendedProps.territoire.split('|');
            territoiresList.forEach(territoire => {
                const trimmedTerritoire = territoire.trim();
                if (trimmedTerritoire) {
                    territories.add(trimmedTerritoire);
                }
            });
        }
        if (event.extendedProps && event.extendedProps.categories) {
            event.extendedProps.categories.forEach(cat => {
                if (typeof cat === 'string') {
                    categories.add(cat);
                } else if (typeof cat === 'object' && cat.name) {
                    categories.add(cat.name);
                }
            });
        }
    });


    // Créer le filtre par ville
    // const cityFilter = document.createElement('div');
    // cityFilter.className = 'filter-group';
    // cityFilter.innerHTML = `
    //     <label for="filter-city">Ville</label>
    //     <select id="filter-city">
    //         <option value="all">Toutes les villes</option>
    //         ${Array.from(cities).sort().map(city => `<option value="${city}">${city}</option>`).join('')}
    //     </select>
    // `;

    // Créer le filtre par territoire
    const territoryFilter = document.createElement('div');
    territoryFilter.className = 'filter-group';
    territoryFilter.innerHTML = `
        <label for="filter-territory">Territoire</label>
        <select id="filter-territory">
            <option value="all">Tous les territoires</option>
            ${Array.from(territories).sort().map(territory => `<option value="${territory}">${territory}</option>`).join('')}
        </select>
    `;
    
    // Créer le filtre par catégorie
    const categoryFilter = document.createElement('div');
    categoryFilter.className = 'filter-group';
    categoryFilter.innerHTML = `
        <label for="filter-category">Catégorie</label>
        <select id="filter-category">
            <option value="all">Toutes les catégories</option>
            ${Array.from(categories).sort().map(category => `<option value="${category}">${category}</option>`).join('')}
        </select>
    `;
    
    // Créer le filtre par date
    const dateFilter = document.createElement('div');
    dateFilter.className = 'filter-group';
    dateFilter.innerHTML = `
        <label for="filter-date">Date</label>
        <input type="date" id="filter-date">
    `;
    
    // Ajouter l'option d'autoload des filtres
    const autoloadFilter = document.createElement('div');
    autoloadFilter.className = 'filter-group autoload-container';
    autoloadFilter.innerHTML = `
        <div class="autoload-switch-container">
            <label for="autoload-filters" class="autoload-label">Filtrage automatique</label>
            <label class="switch">
                <input type="checkbox" id="autoload-filters" checked>
                <span class="slider round"></span>
            </label>
        </div>
    `;
    
    // Créer la section des boutons
    const filterButtons = document.createElement('div');
    filterButtons.className = 'filter-buttons';
    filterButtons.innerHTML = `
        <button id="apply-filters" class="btn btn-primary">Rechercher</button>
        <button id="reset-filters" class="btn btn-secondary btn-sm">Réinitialiser</button>
    `;
    
    // Ajouter tous les filtres au conteneur
    // filtersContainer.appendChild(cityFilter);
    filtersContainer.appendChild(territoryFilter);
    filtersContainer.appendChild(categoryFilter);
    filtersContainer.appendChild(dateFilter);
    filtersContainer.appendChild(autoloadFilter);
    filtersContainer.appendChild(filterButtons);
    
    // Ajouter les styles pour le commutateur d'autoload
    const styleElement = document.createElement('style');
    styleElement.textContent = `
        .autoload-container {
            display: flex !important;
            align-items: center !important;
            justify-content: flex-start !important;
            margin-top: 10px !important;
        }
        .autoload-switch-container {
            display: flex !important;
            align-items: center !important;
            gap: 10px !important;
        }
        .switch {
            position: relative !important;
            display: inline-block !important;
            width: 50px !important;
            height: 24px !important;
        }
        .switch input {
            opacity: 0 !important;
            width: 0 !important;
            height: 0 !important;
        }
        .slider {
            position: absolute !important;
            cursor: pointer !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            bottom: 0 !important;
            background-color: #ccc !important;
            transition: .4s !important;
        }
        .slider:before {
            position: absolute !important;
            content: "" !important;
            height: 16px !important;
            width: 16px !important;
            left: 4px !important;
            bottom: 4px !important;
            background-color: white !important;
            transition: .4s !important;
        }
        input:checked + .slider {
            background-color: #2196F3 !important;
        }
        input:focus + .slider {
            box-shadow: 0 0 1px #2196F3 !important;
        }
        input:checked + .slider:before {
            transform: translateX(26px) !important;
        }
        .slider.round {
            border-radius: 34px !important;
        }
        .slider.round:before {
            border-radius: 50% !important;
        }
        .go-booking-no-results {
            padding: 1.5rem !important;
            margin: 1rem 0 !important;
            text-align: center !important;
            background-color: #f8f9fa !important;
            border-radius: 8px !important;
            color: #6c757d !important;
            font-weight: 500 !important;
        }
    `;
    document.head.appendChild(styleElement);
    
    // Trouver le conteneur du calendrier
    const calendarWrapper = document.querySelector('.go-booking-calendar-container');
    if (calendarWrapper) {
        // Insérer les filtres avant le calendrier
        calendarWrapper.insertBefore(filtersContainer, calendarWrapper.firstChild);
    } else {
        console.error('Conteneur du calendrier non trouvé');
    }
    
    // Fonction pour vérifier si l'autoload est activé
    const isAutoloadEnabled = () => {
        return document.getElementById('autoload-filters')?.checked;
    };
    
    // Ajouter les écouteurs d'événements avec autoload
    document.getElementById('filter-city')?.addEventListener('change', () => {
        if (isAutoloadEnabled()) {
            resetCalendarAndFilter();
        }
    });

    document.getElementById('filter-territory')?.addEventListener('change', () => {
        if (isAutoloadEnabled()) {
            resetCalendarAndFilter();
        }
    });
    
    document.getElementById('filter-category')?.addEventListener('change', () => {
        if (isAutoloadEnabled()) {
            resetCalendarAndFilter();
        }
    });
    
    document.getElementById('filter-date')?.addEventListener('change', () => {
        if (isAutoloadEnabled()) {
            resetCalendarAndFilter();
        }
    });
    
    document.getElementById('apply-filters')?.addEventListener('click', resetCalendarAndFilter);
    
    document.getElementById('reset-filters')?.addEventListener('click', () => {
        // document.getElementById('filter-city').value = 'all';
        document.getElementById('filter-territory').value = 'all';
        document.getElementById('filter-category').value = 'all';
        document.getElementById('filter-date').value = '';
        resetCalendarAndFilter();
    });
    
    // Récupérer et appliquer les filtres sauvegardés s'ils existent
    try {
        const savedFilters = sessionStorage.getItem('goBookingFilters');
        if (savedFilters) {
            const filters = JSON.parse(savedFilters);
            
            // Appliquer les filtres sauvegardés aux champs
            // if (filters.city && document.getElementById('filter-city')) {
            //     document.getElementById('filter-city').value = filters.city;
            // }

            if (filters.territory && document.getElementById('filter-territory')) {
                document.getElementById('filter-territory').value = filters.territory;
            }
            
            if (filters.category && document.getElementById('filter-category')) {
                document.getElementById('filter-category').value = filters.category;
            }
            
            if (filters.date && document.getElementById('filter-date')) {
                document.getElementById('filter-date').value = filters.date;
            }
            
            // Appliquer les filtres automatiquement si au moins un filtre est actif
            if (filters.territory !== 'all' || filters.category !== 'all' || filters.date) {
                // Petit délai pour s'assurer que tout est chargé
                setTimeout(() => {
                    resetCalendarAndFilter();
                }, 100);
            }
        }
    } catch (e) {
        console.error('Erreur lors de la récupération des filtres:', e);
    }
}

// Cache pour les templates
const templateCache = {};

// Ajouter quelques styles CSS directement pour garantir l'affichage correct des détails
function addCustomDetailStyles() {
    if (document.getElementById('go-booking-detail-styles')) return;
    
    const styleElement = document.createElement('style');
    styleElement.id = 'go-booking-detail-styles';
    styleElement.textContent = `
        .fc-flexbox-event {
            cursor: pointer !important;
            transition: transform 0.2s ease-in-out !important;
            position: relative !important;
        }
        
        .fc-flexbox-event:hover {
            transform: translateY(-1px) !important;
        }
        
        .fc-flexbox-event:active {
            transform: translateY(0) !important;
        }
        
        .fc-flexbox-animation-card {
            position: relative !important;
            overflow: hidden !important;
            border-radius: 12px !important;
            transition: none !important;
        }
        
        .fc-flexbox-animation-card .fc-flexbox-event-details {
            display: none !important;
            width: 100% !important;
            box-sizing: border-box !important;
            padding: 1rem !important;
            margin-top: 0 !important;
            background-color: #f8f9fa !important;
            position: relative !important;
            z-index: 1 !important;
        }
        
        .fc-flexbox-animation-card .fc-flexbox-event-details.show {
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
        }
        
        .event-map-container {
            min-height: 250px !important;
            width: 100% !important;
            margin: 1rem 0 !important;
            border-radius: 8px !important;
            overflow: hidden !important;
        }

        .chevron-icon {
            transition: transform 0.3s ease-in-out !important;
            width: 40px !important;
            height: 40px !important;
            opacity: 0.7 !important;
            position: relative !important;
            z-index: 2 !important;
        }
        
        .fc-flexbox-event:hover .chevron-icon {
            opacity: 1 !important;
        }

        .chevron-icon.rotate {
            transform: rotate(180deg) !important;
        }

        .chevron-icon svg {
            width: 100% !important;
            height: 100% !important;
            fill: currentColor !important;
        }

        .event-full-details {
            display: flex !important;
            flex-direction: column !important;
            gap: 1rem !important;
            width: 100% !important;
        }
        
        /* Styles pour les filtres */
        .go-booking-filters {
            display: flex !important;
            flex-wrap: wrap !important;
            gap: 1rem !important;
            margin-bottom: 1.5rem !important;
            padding: 1rem !important;
            border-radius: 8px !important;
            background-color: #f8f9fa !important;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
        }
        
        .filter-group {
            flex: 1 !important;
            min-width: 200px !important;
        }
        
        .filter-group label {
            display: block !important;
            margin-bottom: 0.5rem !important;
            font-weight: 500 !important;
        }
        
        .filter-group select,
        .filter-group input {
            width: 100% !important;
            padding: 0.5rem !important;
            border: 1px solid #ced4da !important;
            border-radius: 4px !important;
            background-color: #fff !important;
        }
        
        .filter-buttons {
            display: flex !important;
            align-items: flex-end !important;
            gap: 0.5rem !important;
            min-width: 200px !important;
        }
        
        #apply-filters {
            flex-grow: 1 !important;
            padding: 0.5rem 1rem !important;
            background-color: #0d6efd !important;
            color: #fff !important;
            border: none !important;
            border-radius: 4px !important;
            cursor: pointer !important;
            font-weight: 500 !important;
        }

        #apply-filters:hover {
            background-color: #0b5ed7 !important;
        }
        
        #reset-filters {
            padding: 0.375rem 0.75rem !important;
            font-size: 0.875rem !important;
            background-color: #6c757d !important;
            color: #fff !important;
            border: none !important;
            border-radius: 4px !important;
            cursor: pointer !important;
        }

        #reset-filters:hover {
            background-color: #5c636a !important;
        }
        
        /* Media queries pour la responsivité */
        @media (max-width: 768px) {
            .go-booking-filters {
                flex-direction: column !important;
            }
            
            .filter-buttons {
                width: 100% !important;
                margin-top: 1rem !important;
            }
        }
        
        /* Style pour le message 'aucun résultat' */
        .no-results {
            padding: 1.5rem !important;
            margin: 1rem 0 !important;
            text-align: center !important;
            background-color: #f8f9fa !important;
            border-radius: 8px !important;
            color: #6c757d !important;
            font-weight: 500 !important;
        }
    `;
    document.head.appendChild(styleElement);
}

// Appeler cette fonction au chargement du document
document.addEventListener('DOMContentLoaded', function() {
    // Ajouter les styles personnalisés
    addCustomDetailStyles();
});

// Fonction pour formater la date en français (jour en chiffres + mois en 3 lettres)
function formatDateHeader(dayGroup) {
    // Tableau des mois en français (3 lettres majuscules)
    const MOIS = ['JAN', 'FEV', 'MAR', 'AVR', 'MAI', 'JUN', 'JUL', 'AOU', 'SEP', 'OCT', 'NOV', 'DEC'];
    
    // Utiliser la date du premier événement du groupe
    if (dayGroup.events && dayGroup.events.length > 0) {
        const eventElement = dayGroup.events[0];
        const eventId = eventElement.getAttribute('data-event-id') || 
                       Array.from(eventElement.classList)
                           .find(cls => cls.startsWith('event-'))?.replace('event-', '');

        if (eventId && window.goBookingCalendarInstance) {
            const fcEvent = window.goBookingCalendarInstance.getEventById(eventId);
            if (fcEvent && fcEvent.start) {
                const startDate = fcEvent.start;
                const jourStart = startDate.getDate();
                const moisStart = MOIS[startDate.getMonth()];
                
                // Vérifier si l'événement a une date de fin (date_fin)
                if (fcEvent.extendedProps && fcEvent.extendedProps.date_fin) {
                    try {
                        // Convertir la date de fin en objet Date
                        const endDateStr = fcEvent.extendedProps.date_fin;
                        const endDate = new Date(endDateStr);
                        
                        // Si la date de fin est valide et différente de la date de début
                        if (!isNaN(endDate) && 
                            (endDate.getDate() !== startDate.getDate() || 
                             endDate.getMonth() !== startDate.getMonth() || 
                             endDate.getFullYear() !== startDate.getFullYear())) {
                            
                            const jourEnd = endDate.getDate();
                            const moisEnd = MOIS[endDate.getMonth()];
                                                        
                            return `${jourStart} ${moisStart} - ${jourEnd} ${moisEnd}`;
                        }
                    } catch (error) {
                        console.error('Erreur lors du parsing de la date de fin:', error);
                    }
                }
                
                return `${jourStart} ${moisStart}`;
            }
        }
    }
    
    // Fallback : essayer de créer une date à partir du texte
    try {
        const date = new Date(dayGroup.dateText);
        if (!isNaN(date)) {
            const jour = date.getDate();
            const mois = MOIS[date.getMonth()];
            return `${jour} ${mois}`;
        }
    } catch (error) {
        console.error('Erreur lors du parsing de la date:', error);
    }
    
    // Si tout échoue, retourner le texte tel quel
    return dayGroup.dateText;
}

function validateParticipant(participant) {
    if (!participant.nom) {
        showNotification('error', 'Le nom est obligatoire');
        return false;
    }
    
    if (participant.email && !isValidEmail(participant.email)) {
        showNotification('error', 'Veuillez entrer une adresse email valide');
        return false;
    }
    
    if (participant.telephone && !isValidPhone(participant.telephone)) {
        showNotification('error', 'Veuillez entrer un numéro de téléphone valide');
        return false;
    }
    
    return true;
}

function handleEventClick(info) {
    // Si c'est un clic sur le bouton d'inscription, ouvrir la modale d'inscription
    if (info.jsEvent.target.closest('.go-booking-inscription-btn')) {
        openInscriptionModal(info.event);
        return false; // Indique à FullCalendar de ne pas traiter davantage l'événement
    }
    
    // Gérer les autres clics sur l'événement
    const eventId = info.event.id;
    const element = info.el;
    
    if (element.closest('.fc-flexbox-animation-card')) {
        return;
    }

    openAnimationModal(info.event);
}

// Fonction pour ouvrir la modale d'inscription
function openInscriptionModal(event) {
    
    // Vérifier que Bootstrap est disponible
    if (typeof bootstrap === 'undefined' || typeof bootstrap.Modal === 'undefined') {
        console.error('Bootstrap n\'est pas disponible');
        alert('Impossible d\'ouvrir la modale d\'inscription : Bootstrap n\'est pas disponible.');
        return;
    }
    
    // Nous allons d'abord charger les sessions disponibles et afficher une modale de sélection
    // avant de rediriger vers la page d'inscription
    showSessionSelectionModal(event);
}

/**
 * Affiche une modale permettant de sélectionner une session avant l'inscription
 */
async function showSessionSelectionModal(event) {
    try {
        
        // Préparer les données de l'événement
        const eventData = {
            id: event.id,
            title: event.title,
            date: event.start ? new Date(event.start).toLocaleDateString() : '',
            lieu_depart: event.extendedProps?.lieu_depart || '',
            places_disponibles: parseInt(event.extendedProps?.places_disponibles) || 0,
            extendedProps: {
                ...event.extendedProps,
                places_disponibles: parseInt(event.extendedProps?.places_disponibles) || 0
            }
        };
        
        
        // Charger les sessions disponibles
        const response = await fetch(goBookingData.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'gobooking_get_sessions',
                nonce: goBookingData.nonce,
                animation_id: event.id
            })
        });

        if (!response.ok) {
            throw new Error('Erreur réseau');
        }

        const result = await response.json();
        
        let availableSessions = [];
        
        if (result.success && result.data && result.data.sessions) {
            availableSessions = result.data.sessions.filter(session => 
                session.places_disponibles && parseInt(session.places_disponibles) > 0
            );
        }
        
        // Créer la modale à deux étapes
        createMultiStepInscriptionModal(eventData, availableSessions);
        
    } catch (error) {
        console.error('Erreur lors de l\'affichage de la modale de sélection de session:', error);
        alert('Une erreur est survenue lors du chargement des sessions. Veuillez réessayer.');
    }
}

/**
 * Crée une modale d'inscription à deux étapes : sélection de session puis formulaire
 */
function createMultiStepInscriptionModal(eventData, availableSessions) {
    
    // Structure HTML de base pour la modale
    const modalHTML = `
        <div class="modal fade" id="sessionSelectionModal" tabindex="-1" role="dialog" aria-labelledby="inscriptionModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="inscriptionModalLabel">Inscription - ${eventData.title}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
                    </div>
                    <div class="modal-body">
                        <!-- Indicateur d'étapes -->
                        <div class="inscription-steps mb-4">
                            <div class="row text-center">
                                <div class="col-6 step-item active" id="step-session">
                                    <div class="step-number">1</div>
                                    <div class="step-label">Choix de la session</div>
                                </div>
                                <div class="col-6 step-item" id="step-form">
                                    <div class="step-number">2</div>
                                    <div class="step-label">Formulaire d'inscription</div>
                                </div>
                            </div>
                            <div class="progress mt-2">
                                <div class="progress-bar" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        
                        <!-- Étape 1: Sélection de session -->
                        <div id="session-selection-step">
                            <div class="animation-info mb-3">
                                <h5>${eventData.title}</h5>
                            </div>
                            
                            ${availableSessions.length > 0 ? `
                                <div class="sessions-container">
                                    <div class="row mb-3">
                                        <div class="col-md-6">
                                            <select class="form-select" id="activity-filter">
                                                <option value="">Toutes les activités</option>
                                                ${[...new Set(availableSessions.map(session => session.activite_titre))].filter(Boolean).map(activity => `
                                                    <option value="${activity}">${activity}</option>
                                                `).join('')}
                                            </select>
                                        </div>
                                    </div>
                                    <h6>Sélectionnez une session pour vous inscrire :</h6>
                                    <div class="sessions-list list-group mt-3">
                                        ${availableSessions.map((session, index) => `
                                            <button type="button" class="list-group-item list-group-item-action" 
                                                    data-session-id="${session.id}" 
                                                    data-session-date="${session.formatted_date || ''}" 
                                                    data-session-day="${session.day_name || ''}"
                                                    data-session-horaire="${session.horaire || `${session.heure_debut || ''} - ${session.heure_fin || ''}`}"
                                                    data-session-lieu="${session.lieu_depart || 'Lieu non spécifié'}"
                                                    data-session-places="${session.places_disponibles}"
                                                    data-max-inscriptions="${session.max_inscriptions_user || eventData.extendedProps?.max_inscriptions_user || 2}">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <strong>${session.formatted_date || ''} (${session.day_name || ''})</strong>
                                                        <div>${session.horaire || `${session.heure_debut || ''} - ${session.heure_fin || ''}`}</div>
                                                        <div class="small text-muted">${session.lieu_depart || 'Lieu non spécifié'}</div>
                                                        ${session.has_activite && session.activite_titre ? 
                                                            `<div class="small text-info mt-1"><i class="bi bi-info-circle"></i> Activité: ${session.activite_titre}</div>` : ''}
                                                    </div>
                                                    <span class="badge ${parseInt(session.places_disponibles) > 0 ? 'bg-success' : 'bg-danger'} d-flex align-items-center">
                                                        <i class="bi ${parseInt(session.places_disponibles) > 0 ? 'bi-person-check' : 'bi-person-x'} me-1"></i>
                                                        ${parseInt(session.places_disponibles) === 0 
                                                            ? 'Complet' 
                                                            : `${parseInt(session.places_disponibles)} place${parseInt(session.places_disponibles) !== 1 ? 's' : ''} sur ${parseInt(session.places_totales)}`}
                                                    </span>
                                                </div>
                                            </button>
                                        `).join('')}
                                    </div>
                                </div>
                            ` : `
                                <div class="no-sessions alert alert-warning">
                                    Aucune session avec des places disponibles pour cette animation.
                                </div>
                            `}
                        </div>
                        
                        <!-- Étape 2: Formulaire d'inscription -->
                        <div id="inscription-form-step" style="display: none;">
                            <div class="session-details card mb-4">
                                <div class="card-body">
                                    <h5 class="card-title">Détails de la session</h5>
                                    <p class="session-date mb-1"><i class="bi bi-calendar"></i> <span></span></p>
                                    <p class="session-horaire mb-1"><i class="bi bi-clock"></i> <span></span></p>
                                    <p class="session-lieu mb-1"><i class="bi bi-geo-alt"></i> <span></span></p>
                                    <p class="session-places mb-1">
                                        <i class="bi bi-people"></i>
                                        <span class="badge ${parseInt(eventData.extendedProps?.places_disponibles) > 0 ? 'bg-success' : 'bg-danger'}">
                                            <i class="bi bi-person-check me-1"></i>
                                            ${parseInt(eventData.extendedProps?.places_disponibles)} place${parseInt(eventData.extendedProps?.places_disponibles) !== 1 ? 's' : ''} disponible${parseInt(eventData.extendedProps?.places_disponibles) !== 1 ? 's' : ''}
                                        </span>
                                    </p>
                                </div>
                            </div>
                            
                            <form id="go-booking-inscription-form" class="needs-validation" novalidate>
                                <input type="hidden" name="animation_id" id="animation_id" value="${eventData.id}">
                                <input type="hidden" name="session_id" id="session_id" value="">
                                
                                <h5 class="mb-3">Participant principal</h5>
                                <div class="row g-3">
                                    <div class="col-md-6">
                                        <label for="nom" class="form-label">Nom *</label>
                                        <input type="text" class="form-control" id="nom" name="nom" placeholder="Votre nom" required>
                                        <div class="invalid-feedback">
                                            Veuillez saisir votre nom
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="prenom" class="form-label">Prénom *</label>
                                        <input type="text" class="form-control" id="prenom" name="prenom" placeholder="Votre prénom" required>
                                        <div class="invalid-feedback">
                                            Veuillez saisir votre prénom
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="email" class="form-label">Email *</label>
                                        <input type="email" class="form-control" id="email" name="email" placeholder="exemple@email.com" required>
                                        <div class="invalid-feedback">
                                            Veuillez saisir une adresse email valide
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="telephone" class="form-label">Téléphone *</label>
                                        <input type="tel" class="form-control" id="telephone" name="telephone" placeholder="0612345678 (10 chiffres)" pattern="0[1-9][0-9]{8}" required>
                                        <div class="invalid-feedback">
                                            Le numéro de téléphone doit contenir exactement 10 chiffres et commencer par 0
                                        </div>
                                    </div>
                                </div>

                                <div class="participants-supplementaires mt-4">
                                    <h5 class="mb-3">Participants supplémentaires</h5>
                                    <div class="participants-list"></div>
                                    <button type="button" class="btn btn-outline-primary w-100 mt-3 add-participant-btn">
                                        <i class="bi bi-plus-circle"></i> Ajouter un participant
                                    </button>
                                </div>
                                
                                <div class="form-check mt-4">
                                    <input class="form-check-input" type="checkbox" value="1" id="accept_terms" name="accept_terms" required>
                                    <label class="form-check-label" for="accept_terms">
                                        J'autorise les équipes du SMMAG à conserver mes données personnelles transmises par le présent formulaire. Conformément à la RGPD, les informations recueillies sont enregistrées dans un fichier informatisé par le SMMAG pour archiver les demandes d'inscription aux animations. La base légale du traitement est celle du consentement. Les données collectées seront communiquées aux seules équipes du SMMAG en charge des animations. Voir notre <a href="/politique-de-gestion-des-cookies/" target="_blank">politique de gestion des cookies</a>. *
                                    </label>
                                    <div class="invalid-feedback">
                                        Vous devez accepter les conditions générales pour continuer
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
                        <button type="button" class="btn btn-outline-secondary back-btn" style="display: none;">Retour</button>
                        <button type="button" class="btn btn-primary next-btn">Continuer</button>
                        <button type="button" class="btn btn-success submit-inscription-btn" style="display: none;">Confirmer l'inscription</button>
                    </div>
                </div>
            </div>
        </div>
    `;
    
    // Ajouter des styles personnalisés
    if (!document.getElementById('multi-step-modal-styles')) {
        const styleElement = document.createElement('style');
        styleElement.id = 'multi-step-modal-styles';
        styleElement.textContent = `
            .inscription-steps .step-item {
                position: relative;
                padding: 15px 5px;
            }
            
            .inscription-steps .step-number {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                background-color: #e9ecef;
                color: #6c757d;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0 auto 8px;
                font-weight: bold;
            }
            
            .inscription-steps .step-item.active .step-number {
                background-color: #0d6efd;
                color: white;
            }
            
            .inscription-steps .step-label {
                font-size: 0.9rem;
            }
            
            .session-details {
                background-color: #f8f9fa;
                border-left: 4px solid #0d6efd;
            }
            
            .list-group-item.selected {
                border-color: #0d6efd;
                background-color: rgba(13, 110, 253, 0.1);
            }
            
            .participant-group.card {
                border: 1px solid #dee2e6;
                border-radius: 0.375rem;
                overflow: hidden;
                margin-bottom: 1rem;
                box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
            }
            
            .participant-group .card-header {
                background-color: #f8f9fa;
                border-bottom: 1px solid #dee2e6;
                padding: 0.75rem 1rem;
            }
            
            .participant-group .card-body {
                padding: 1rem;
            }
            
            .remove-participant-btn {
                cursor: pointer;
                transition: all 0.2s;
            }
            
            .remove-participant-btn:hover {
                opacity: 0.7;
            }
            
            .participants-list {
                margin-bottom: 1rem;
            }
            
            .add-participant-btn {
                transition: all 0.3s;
            }
            
            .add-participant-btn:hover {
                background-color: #0d6efd;
                color: white;
            }
            
            #activity-filter {
                border-radius: 0.375rem;
                border: 1px solid #dee2e6;
                padding: 0.5rem;
                background-color: #fff;
                transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
            }
            
            #activity-filter:focus {
                border-color: #86b7fe;
                box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
            }
            
            .sessions-container {
                background-color: #f8f9fa;
                padding: 1.5rem;
                border-radius: 0.5rem;
                margin-bottom: 1.5rem;
            }
        `;
        document.head.appendChild(styleElement);
    }
    
    // Ajouter la modale au DOM
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    // Récupérer l'élément de la modale
    const modal = document.getElementById('sessionSelectionModal');
    if (!modal) {
        console.error('Impossible de trouver la modale après l\'avoir ajoutée au DOM');
        return;
    }
    
    // Variable pour stocker la session sélectionnée
    let selectedSessionId = null;
    let selectedSessionData = null;
    let currentParticipantCount = 0;
    
    // Définir la logique pour naviguer entre les étapes
    const sessionStep = modal.querySelector('#session-selection-step');
    const formStep = modal.querySelector('#inscription-form-step');
    const nextBtn = modal.querySelector('.next-btn');
    const backBtn = modal.querySelector('.back-btn');
    const submitBtn = modal.querySelector('.submit-inscription-btn');
    const progressBar = modal.querySelector('.progress-bar');
    const sessionStepIndicator = modal.querySelector('#step-session');
    const formStepIndicator = modal.querySelector('#step-form');
    
    // Fonction pour passer à l'étape suivante (formulaire)
    const goToFormStep = () => {
        sessionStep.style.display = 'none';
        formStep.style.display = 'block';
        nextBtn.style.display = 'none';
        backBtn.style.display = 'inline-block';
        submitBtn.style.display = 'inline-block';
        progressBar.style.width = '100%';
        sessionStepIndicator.classList.remove('active');
        formStepIndicator.classList.add('active');
        
        // Mettre à jour les détails de la session dans le formulaire
        updateSessionDetails(selectedSessionData);
        
        // Mettre à jour le gestionnaire de participants avec le max_inscriptions_user de la session sélectionnée
        if (modal._participantManager && selectedSessionData && selectedSessionData.max_inscriptions_user) {
            const maxInscriptionsUser = parseInt(selectedSessionData.max_inscriptions_user);
            if (!isNaN(maxInscriptionsUser) && maxInscriptionsUser > 0) {
                // max_inscriptions_user - 1 car l'utilisateur principal compte comme 1 participant
                const maxParticipants = maxInscriptionsUser - 1;
                modal._participantManager.setMaxParticipants(maxParticipants);
            }
        }
    };
    
    // Fonction pour revenir à l'étape précédente (sélection de session)
    const goToSessionStep = () => {
        formStep.style.display = 'none';
        sessionStep.style.display = 'block';
        nextBtn.style.display = 'inline-block';
        backBtn.style.display = 'none';
        submitBtn.style.display = 'none';
        progressBar.style.width = '50%';
        formStepIndicator.classList.remove('active');
        sessionStepIndicator.classList.add('active');
        
        // Réinitialiser les participants supplémentaires lorsqu'on revient à l'étape de sélection
        if (modal._participantManager) {
            modal._participantManager.resetParticipants();
        }
    };
    
    // Fonction pour mettre à jour les détails de la session
    const updateSessionDetails = (sessionData) => {
        document.getElementById('session_id').value = sessionData.id;
        modal.querySelector('.session-date span').textContent = `${sessionData.date}`;
        modal.querySelector('.session-horaire span').textContent = `${sessionData.horaire}`;
        modal.querySelector('.session-lieu span').textContent = `${sessionData.lieu}`;
        
        const placesCount = parseInt(sessionData.places);
        const placesElement = modal.querySelector('.session-places');
        placesElement.innerHTML = `
            <i class="bi bi-people"></i>
            <span class="badge ${placesCount > 0 ? 'bg-success' : 'bg-danger'} ms-2">
                ${placesCount} place${placesCount > 1 ? 's' : ''} disponible${placesCount > 1 ? 's' : ''}
            </span>
        `;
        
        // Ajouter les informations d'activité si disponibles
        const sessionDetailsCard = modal.querySelector('.session-details .card-body');
        
        // Supprimer l'ancienne information d'activité si elle existe
        const existingActivityInfo = sessionDetailsCard.querySelector('.session-activity');
        if (existingActivityInfo) {
            existingActivityInfo.remove();
        }
        
        // Ajouter la nouvelle information d'activité si disponible
        if (sessionData.has_activite && sessionData.activite_titre) {
            const activityInfo = document.createElement('div');
            activityInfo.className = 'session-activity mt-2';
            activityInfo.innerHTML = `
                <p class="mb-1"><strong><i class="bi bi-info-circle"></i> Activité:</strong> ${sessionData.activite_titre}</p>
                ${sessionData.activite_description ? `<p class="small text-muted">${sessionData.activite_description}</p>` : ''}
            `;
            sessionDetailsCard.appendChild(activityInfo);
        }
    };
    
    // Gestion du clic sur une session
    const sessionItems = modal.querySelectorAll('.sessions-list .list-group-item');
    
    // Fonction pour filtrer les sessions par activité
    const filterSessionsByActivity = (activity) => {
        sessionItems.forEach(item => {
            const sessionActivity = item.querySelector('.text-info')?.textContent.replace('Activité: ', '').trim() || '';
            if (!activity || sessionActivity === activity) {
                item.style.display = 'block';
            } else {
                item.style.display = 'none';
            }
        });
    };

    // Gestion du changement de filtre d'activité
    const activityFilter = modal.querySelector('#activity-filter');
    if (activityFilter) {
        activityFilter.addEventListener('change', (e) => {
            filterSessionsByActivity(e.target.value);
            // Désélectionner la session actuelle
            sessionItems.forEach(el => el.classList.remove('selected'));
            selectedSessionId = null;
            selectedSessionData = null;
            nextBtn.disabled = true;
        });
    }

    sessionItems.forEach(item => {
        item.addEventListener('click', function() {
            // Désélectionner tous les éléments
            sessionItems.forEach(el => el.classList.remove('selected'));
            
            // Sélectionner cet élément
            this.classList.add('selected');
            
            // Enregistrer les données de la session
            selectedSessionId = this.dataset.sessionId;
            selectedSessionData = {
                id: this.dataset.sessionId,
                date: this.dataset.sessionDate,
                day: this.dataset.sessionDay,
                horaire: this.dataset.sessionHoraire,
                lieu: this.dataset.sessionLieu,
                places: this.dataset.sessionPlaces,
                max_inscriptions_user: this.dataset.maxInscriptions,
                disable_native_inscription: this.dataset.disableNativeInscription,
                external_inscription_url: this.dataset.externalInscriptionUrl,
                external_inscription_label: this.dataset.externalInscriptionLabel
            };
            
            // Activer le bouton suivant
            nextBtn.disabled = false;
        });
    });
    
    // Si une seule session est disponible, la sélectionner automatiquement
    if (sessionItems.length === 1) {
        sessionItems[0].click();
    } else {
        // Désactiver le bouton suivant jusqu'à ce qu'une session soit sélectionnée
        nextBtn.disabled = true;
    }
    
    // Gérer le clic sur le bouton "Continuer"
    nextBtn.addEventListener('click', () => {
        if (selectedSessionId) {
            goToFormStep();
        } else {
            alert('Veuillez sélectionner une session pour continuer.');
        }
    });
    
    // Gérer le clic sur le bouton "Retour"
    backBtn.addEventListener('click', goToSessionStep);
    
    // Gérer l'ajout de participants supplémentaires
    const addParticipantBtn = modal.querySelector('.add-participant-btn');
    const participantsList = modal.querySelector('.participants-list');
    
    if (addParticipantBtn && participantsList) {
        // N'ajoutons PAS d'écouteur d'événement ici, car setupParticipantsManagement le fera
        // Nous supprimons ce code pour éviter les doublons d'écouteurs
    }
    
    // Gérer la soumission du formulaire
    submitBtn.addEventListener('click', async () => {
        const form = modal.querySelector('#go-booking-inscription-form');
        if (!form) return;
        
        // Activer les classes Bootstrap pour la validation
        form.classList.add('was-validated');
        
        // Si nous avons un gestionnaire de participants, utilisons-le pour la soumission
        if (modal._participantManager) {
            // Vérifier si le formulaire est valide selon la validation HTML5
            if (!form.checkValidity()) {
                // Faire défiler jusqu'au premier champ invalide
                const firstInvalid = form.querySelector(':invalid');
                if (firstInvalid) {
                    firstInvalid.focus();
                    firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return; // Ne pas soumettre le formulaire si invalide
            }
            
            form.dataset.eventId = eventData.id;
            const success = await modal._participantManager.handleSubmit(form);
            
            if (success) {
                // Fermer la modale
                const bsModal = bootstrap.Modal.getInstance(modal);
                if (bsModal) {
                    bsModal.hide();
                }
                
                // Afficher un message de succès
                showNotification('success', 'Votre inscription a été enregistrée avec succès !');
                
                // Recharger la page ou mettre à jour l'interface si nécessaire
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }
            
            return; // Sortir car le gestionnaire de participants s'est occupé de la soumission
        }
        
        // Si nous n'avons pas de gestionnaire de participants, utiliser l'approche classique
        // Activer la validation du formulaire
        form.classList.add('was-validated');
        
        // Vérifier si le formulaire est valide
        if (form.checkValidity()) {
            try {
                // Désactiver le bouton de soumission et afficher un indicateur de chargement
                submitBtn.disabled = true;
                submitBtn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Traitement...';
                
                // Collecter les données du formulaire
                const formData = new FormData(form);
                
                // Envoyer les données via AJAX
                const response = await fetch(goBookingData.ajax_url, {
                    method: 'POST',
                    body: formData
                });
                
                const result = await response.json();
                
                if (result.success) {
                    // Fermer la modale
                    const bsModal = bootstrap.Modal.getInstance(modal);
                    if (bsModal) {
                        bsModal.hide();
                    }
                    
                    // Afficher un message de succès
                    alert('Votre inscription a été enregistrée avec succès !');
                    
                    // Recharger la page ou mettre à jour l'interface si nécessaire
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    // Afficher un message d'erreur
                    alert('Erreur lors de l\'inscription : ' + (result.data?.message || 'Une erreur est survenue.'));
                    
                    // Réactiver le bouton de soumission
                    submitBtn.disabled = false;
                    submitBtn.innerHTML = 'Confirmer l\'inscription';
                }
            } catch (error) {
                console.error('Erreur lors de la soumission du formulaire :', error);
                alert('Une erreur est survenue lors de l\'inscription. Veuillez réessayer.');
                
                // Réactiver le bouton de soumission
                submitBtn.disabled = false;
                submitBtn.innerHTML = 'Confirmer l\'inscription';
            }
        } else {
            // Faire défiler jusqu'au premier champ invalide
            const firstInvalid = form.querySelector(':invalid');
            if (firstInvalid) {
                firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    });
    
    // Nettoyer après la fermeture de la modale
    modal.addEventListener('hidden.bs.modal', function() {
        cleanupExistingModals();
    });
    
    // Initialiser et afficher la modale
    const bsModal = new bootstrap.Modal(modal);
    bsModal.show();
    
    // Configurer le gestionnaire de participants avec la limite max_inscriptions_user
    // Cette fonction va limiter le nombre de participants supplémentaires à (max_inscriptions_user - 1)
    // car l'utilisateur principal compte comme 1 participant
    setupParticipantsManagement(modal, eventData);
    
    // Nettoyer après la fermeture de la modale
    modal.addEventListener('hidden.bs.modal', function() {
        cleanupExistingModals();
    });
    
    // Ajouter un gestionnaire d'événement pour réinitialiser les participants lorsque la modale est fermée
    modal.addEventListener('hidden.bs.modal', () => {
        if (modal._participantManager) {
            modal._participantManager.resetParticipants();
        }
    });
    
    return modal;
}

/**
 * Crée le HTML pour un participant supplémentaire
 * Cette fonction est maintenant obsolète et sera remplacée par ParticipantManager
 * mais nous la conservons pour compatibilité avec d'autres parties du code
 */
function createParticipantHtml(index) {
    console.warn('createParticipantHtml est obsolète, utilisez ParticipantManager à la place');
    return `
        <div class="participant-group card mb-3" data-index="${index}">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h6 class="mb-0">Participant ${index + 1}</h6>
                <button type="button" class="btn-close remove-participant-btn" aria-label="Supprimer"></button>
            </div>
            <div class="card-body">
                <div class="row g-3">
                    <div class="col-md-6">
                        <label class="form-label">Nom *</label>
                        <input type="text" class="form-control" name="participants[${index}][nom]" required>
                        <div class="invalid-feedback">
                            Veuillez saisir le nom
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Prénom *</label>
                        <input type="text" class="form-control" name="participants[${index}][prenom]" required>
                        <div class="invalid-feedback">
                            Veuillez saisir le prénom
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Email</label>
                        <input type="email" class="form-control" name="participants[${index}][email]">
                        <div class="invalid-feedback">
                            Veuillez saisir une adresse email valide
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Téléphone</label>
                        <input type="tel" class="form-control" name="participants[${index}][telephone]">
                        <div class="invalid-feedback">
                            Veuillez saisir un numéro de téléphone valide
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
}

/**
 * Nettoie les modales existantes et les résidus
 */
function cleanupExistingModals() {
    // Supprimer toute modale existante
    const existingModal = document.getElementById('sessionSelectionModal');
    if (existingModal) {
        try {
            const oldBsModal = bootstrap.Modal.getInstance(existingModal);
            if (oldBsModal) oldBsModal.dispose();
            existingModal.remove();
        } catch (e) {
        }
    }
    
    // Nettoyer les résidus
    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
}

// Remplacer complètement la fonction setupParticipantsManagement existante
function setupParticipantsManagement(modal, eventData) {
    
    // Utiliser le formulaire entier comme conteneur au lieu de seulement les participants supplémentaires
    const participantsContainer = modal.querySelector('#go-booking-inscription-form');
    if (!participantsContainer) {
        console.error('Formulaire d\'inscription non trouvé dans la modale');
        return;
    }
    
    // Supprimez tous les écouteurs existants pour éviter les doublons
    const addButton = modal.querySelector('.add-participant-btn');
    if (addButton) {
        // Cloner et remplacer le bouton pour supprimer tous les écouteurs existants
        const newButton = addButton.cloneNode(true);
        addButton.parentNode.replaceChild(newButton, addButton);
    }
    
    if (typeof ParticipantManager !== 'function') {
        console.error('ParticipantManager n\'est pas encore chargé ou n\'est pas une fonction. Essayez de recharger la page.');
        showNotification('error', 'Erreur de chargement du gestionnaire de participants. Veuillez rafraîchir la page.');
        return;
    }
    
    // Initialiser le gestionnaire de participants
    try {
        const participantManager = new ParticipantManager(participantsContainer);
        
        // Récupérer le nombre maximum de participants par utilisateur depuis les données de l'événement
        // Par défaut, si max_inscriptions_user n'est pas défini, on autorise 1 participant supplémentaire
        const maxInscriptionsUser = eventData.extendedProps?.max_inscriptions_user || 2;
        
        // Calculer le nombre maximum de participants supplémentaires
        // max_inscriptions_user - 1 car l'utilisateur principal compte comme 1 participant
        const maxParticipants = maxInscriptionsUser - 1;
        participantManager.setMaxParticipants(maxParticipants);
        
        // Stocker l'instance dans la modale pour y accéder plus tard si nécessaire
        modal._participantManager = participantManager;
        
        // Désactiver les anciennes fonctions pour éviter les conflits
        window.addParticipant = () => {
            console.warn('Cette fonction est désactivée. Utilisez ParticipantManager.');
        };
        
        return participantManager;
    } catch (error) {
        console.error('Erreur lors de l\'initialisation de ParticipantManager:', error);
        showNotification('error', 'Erreur lors de l\'initialisation du gestionnaire de participants.');
        return null;
    }
}

// Ajouter un écouteur d'événements global pour tous les clics
document.addEventListener('click', function(e) {
    // Vérifier si le clic est sur ou dans un bouton d'inscription
    const inscriptionBtn = e.target.closest('.go-booking-inscription-btn');
    if (inscriptionBtn) {
        
        // Récupérer l'ID de l'événement
        const eventId = inscriptionBtn.getAttribute('data-event-id');
        if (eventId && window.goBookingCalendarInstance) {
            const event = window.goBookingCalendarInstance.getEventById(eventId);
            if (event) {
                openInscriptionModal(event);
                e.preventDefault();
                e.stopPropagation();
            } else {
                console.error('Événement non trouvé pour l\'ID:', eventId);
            }
        } else {
            console.error('ID d\'événement non trouvé ou instance de calendrier non disponible');
        }
    }
});

// Ajoutez cette fonction pour vérifier si d'autres éléments recouvrent vos boutons
function checkOverlappingElements() {
    const buttons = document.querySelectorAll('.go-booking-inscription-btn');
    
    buttons.forEach((btn, index) => {
        const rect = btn.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        
        // Obtenir tous les éléments à cette position
        const elements = document.elementsFromPoint(centerX, centerY);
                
        // Vérifier si le bouton est le premier élément cliquable
        const buttonIndex = elements.indexOf(btn);
        if (buttonIndex > 0) {
            console.warn(`Le bouton #${index} est recouvert par:`, elements.slice(0, buttonIndex));
        }
    });
}

// Ajouter à la fin de l'initialisation du calendrier
window.goBookingCalendarInstance = calendar;
setTimeout(checkOverlappingElements, 1500);

/**
 * Charge et affiche les sessions multiples d'une animation
 */
async function loadAnimationSessions(eventId) {
    try {
        // Récupérer les sessions via AJAX
        const response = await fetch(goBookingData.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'gobooking_get_sessions',
                nonce: goBookingData.nonce,
                animation_id: eventId
            })
        });

        const result = await response.json();
        
        if (!result.success || !result.data.sessions || result.data.sessions.length === 0) {
            return null; // Aucune session trouvée
        }
        
        // Si une seule session, retourner simplement celle-ci
        if (result.data.sessions.length === 1) {
            return result.data.sessions[0];
        }
        
        // Afficher les sessions multiples dans un sélecteur
        const sessionsContainer = document.createElement('div');
        sessionsContainer.className = 'animation-sessions mb-4';
        
        const sessionsTitle = document.createElement('h5');
        sessionsTitle.className = 'mb-3';
        sessionsTitle.textContent = 'Sessions disponibles';
        sessionsContainer.appendChild(sessionsTitle);
        
        const sessionsList = document.createElement('div');
        sessionsList.className = 'list-group';
        
        result.data.sessions.forEach(session => {
            const sessionItem = document.createElement('button');
            sessionItem.type = 'button';
            sessionItem.className = 'list-group-item list-group-item-action d-flex justify-content-between align-items-center';
            sessionItem.dataset.sessionId = session.id;
            sessionItem.dataset.date = session.date;
            sessionItem.dataset.heureDebut = session.heure_debut;
            sessionItem.dataset.heureFin = session.heure_fin;
            
            const sessionInfo = document.createElement('div');
            sessionInfo.innerHTML = `
                <strong>${session.formatted_date} (${session.day_name})</strong>
                <div>${session.horaire}</div>
            `;
            
            const sessionBadge = document.createElement('span');
            sessionBadge.className = `badge bg-${session.places_disponibles > 0 ? 'success' : 'danger'}`;
            sessionBadge.textContent = `${session.places_disponibles} places`;
            
            sessionItem.appendChild(sessionInfo);
            sessionItem.appendChild(sessionBadge);
            
            // Ajouter l'événement de clic pour sélectionner une session
            sessionItem.addEventListener('click', () => {
                // Retirer la classe active de tous les éléments
                document.querySelectorAll('.animation-sessions .list-group-item').forEach(item => {
                    item.classList.remove('active');
                });
                
                // Ajouter la classe active à l'élément cliqué
                sessionItem.classList.add('active');
                
                // Mettre à jour les informations affichées
                const dateElement = document.querySelector('.animation-date');
                if (dateElement) {
                    dateElement.textContent = `${session.formatted_date} (${session.day_name})`;
                }
                
                const timeElement = document.querySelector('.animation-time');
                if (timeElement) {
                    timeElement.textContent = session.horaire;
                }
                
                const placesElement = document.querySelector('.places-disponibles');
                if (placesElement) {
                    placesElement.textContent = session.places_disponibles;
                    placesElement.className = `places-disponibles badge bg-${session.places_disponibles > 0 ? 'success' : 'danger'}`;
                }
                
                // Mettre à jour le bouton d'inscription
                const registerButton = document.querySelector('.register-btn');
                if (registerButton) {
                    registerButton.dataset.sessionId = session.id;
                    registerButton.disabled = session.places_disponibles <= 0;
                }
            });
            
            sessionsList.appendChild(sessionItem);
        });
        
        sessionsContainer.appendChild(sessionsList);
        
        // Ajouter le conteneur des sessions au modal
        const modalBody = document.querySelector('.animation-details .modal-body');
        if (modalBody) {
            // Insérer après la description
            const description = modalBody.querySelector('.animation-description');
            if (description) {
                description.parentNode.insertBefore(sessionsContainer, description.nextSibling);
            } else {
                modalBody.insertBefore(sessionsContainer, modalBody.firstChild);
            }
            
            // Sélectionner la première session par défaut
            const firstSession = sessionsList.querySelector('.list-group-item');
            if (firstSession) {
                firstSession.click();
            }
        }
        
        return result.data.sessions[0]; // Retourner la première session par défaut
    } catch (error) {
        console.error('Erreur lors du chargement des sessions :', error);
        return null;
    }
}

// Modification de la fonction d'ouverture du modal d'inscription
function openSessionInscriptionModal(event) {
    // Récupérer l'ID de la session sélectionnée
    const sessionId = event.currentTarget.dataset.sessionId || null;
    
    // Construire l'URL avec l'ID de la session
    let inscriptionUrl = `${goBookingData.site_url}?animation_id=${event.id}`;
    
    if (sessionId) {
        inscriptionUrl += `&session_id=${sessionId}`;
    }
    
    // Rediriger vers la page d'inscription
    window.location.href = inscriptionUrl;
}

// Variables globales pour le module
let calendar;
let earliestEventStart;
let queuedClicks = [];
let processingClick = false;

// Fonction désactivée - la gestion des couleurs est maintenant dans animation-card.js
function getCategoryColor(category) {
    return 'transparent';
}

function applyEventStyles(el, event) {
    return;
}

// Fonction pour réinitialiser complètement le calendrier et appliquer les filtres
function resetCalendarAndFilter() {
    if (!window.goBookingCalendarInstance) return;
    
    // 1. Nettoyer les animations ouvertes
    document.querySelectorAll('.fc-flexbox-event-details.show').forEach(detail => {
        detail.classList.remove('show');
        detail.style.display = 'none';
        detail.removeAttribute('data-initialized');
    });
    
    // Réinitialiser les icônes chevrons
    document.querySelectorAll('.chevron-icon.rotate').forEach(chevron => {
        chevron.classList.remove('rotate');
    });
    
    // 2. Nettoyer les cartes Leaflet
    if (window.goBookingMaps) {
        Object.keys(window.goBookingMaps).forEach(mapId => {
            try {
                window.goBookingMaps[mapId].remove();
                delete window.goBookingMaps[mapId];
            } catch (e) {
                console.error(`Erreur lors du nettoyage de la carte ${mapId}:`, e);
            }
        });
    }
    
    // 3. Appliquer les filtres
    filterEvents();
}
